import { buildDashboardFilterPayload } from "../utils/filterPayloadBuilder";
let apiUrl = process.env.REACT_APP_ANTHROPOD_API_URL;
// let apiUrl = 'http://127.0.0.1:8000'

function getClientDisplayInfo() {
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const innerWidth = window.innerWidth;
  const innerHeight = window.innerHeight;
  const zoomLevel = Math.round((window.outerWidth / window.innerWidth) * 100);

  return {
    screenWidth,
    screenHeight,
    innerWidth,
    innerHeight,
    zoomLevel: `${zoomLevel}%`,
  };
}


class Server {
    async googleLogin(code) {
      const config = getClientDisplayInfo()
        let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/dashboard_login/`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ code, 'window_size_details': config }),
          });
        return resp;
    }
    async microsoftLogin(code) {
      const config = getClientDisplayInfo()
        let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/dashboard_login/`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ code, provider: 'microsoft', is_microsoft_login: true, 'window_size_details': config }),
          });
        return resp;
    }
    async sendVerificationOTP(email, user_type){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/send_email_otp/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: email, user_type }),
      });
      return resp;
    }
    async otpValidation(email, otp){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/otp_validation/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: email, otp: otp }),
      });
      return resp;
    }
    async resetPassword(email, newPassword){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/update_password/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: email, new_password: newPassword }),
      });
      return resp;
    }
    async createNewOrgansationUser(email, password, name, organization, industry, numberOfAgents, isGoogleLogin, isMicrosoftLogin = false){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/create_new_dashboard_client/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password, name, organisation_name: organization, industry, number_of_agents: numberOfAgents, is_google_login: isGoogleLogin, is_microsoft_login: isMicrosoftLogin }),
      })
      return resp;
    }
    async login(email, password){
      const config = getClientDisplayInfo()
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/dashboard_login/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ email, password, 'window_size_details': config }),
      });
      return resp;
    }
    async testMetabaseApi(metabaseNum, params, menu, subMenu, client_id, service_id){
      let resp = await fetch(`${apiUrl}/api/internal/dashboard/metabase_dashboard_url/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ metabase_number: metabaseNum, params, menu, subMenu, client_id, service_id }),
      });
      let data = await resp.json();
      return {data, status: resp.status};
    }
    async getUserData() {
      let resp = await fetch(`${apiUrl}/api/internal/dashboard/user_data/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',  // Automatically sends the cookies stored from the previous request
      });
      let data = await resp.json();
      return data;
    }
    async generateRefreshToken(data) {
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/regenerate_refresh_token/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',  // Automatically sends the cookies stored from the previous request
        body: JSON.stringify({ ...data })
      });
      return resp;
    }
    async logout() {
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/dashboard_logout/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include' // Automatically sends the cookies stored from the previous request
      });
      return resp;
    }
    async getCallDetails(client_id, service_id, id, menu, submenu, email, url, hard_refresh) {
      const encodedCallId = encodeURIComponent(id);
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/call_details/?client_id=${client_id}&service_id=${service_id}&id=${encodedCallId}&menu=${menu}&submenu=${submenu}&email=${email}&url=${url}${hard_refresh ? '&hard_refresh=1' : ''}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include' // Automatically sends the cookies stored from the previous request
      });
      return resp;
    }
    async getCallRecordingLink(call_id, client_id, service_id, menu, submenu, email, url) {
      let encodedCallId = encodeURIComponent(call_id);
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/call_recording_link/?call_id=${encodedCallId}&client_id=${client_id}&service_id=${service_id}&menu=${menu}&submenu=${submenu}&email=${email}&url=${url}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include' // Automatically sends the cookies stored from the previous request
      });
      return resp;
    }
    async getConversationDetails(conversation_id, client_id, service_id, menu, submenu, email) {
      let encodedConversationId = encodeURIComponent(conversation_id);
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/conversation_details/?conversation_id=${encodedConversationId}&client_id=${client_id}&service_id=${service_id}&menu=${menu}&submenu=${submenu}&email=${email}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include' // Automatically sends the cookies stored from the previous request
      });
      return resp;
    }
    async getFeedbackData(client_id, service_id, call_id, anthro_id, menu, submenu) {
      let encodedCallId = encodeURIComponent(call_id || '');
      let resp = await fetch(`${apiUrl}/api/internal/dashboard/feedback_data/?client_id=${client_id}&service_id=${service_id}&call_id=${encodedCallId}&anthro_id=${anthro_id}&menu=${menu}&submenu=${submenu}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include' // Automatically sends the cookies stored from the previous request
      });
      return resp;
    }
    async postFeedback(obj) {
      let resp = await fetch(`${apiUrl}/api/internal/dashboard/feedback_data/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...obj}),
        credentials: 'include' // Automatically sends the cookies stored from the previous request
      });
      return resp;
    }
    async getCustomersDetails(client_id, service_id, customer_id, email, menu, submenu, url, hard_refresh) {
      const encodedCallId = encodeURIComponent(customer_id);
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/customer_details/?client_id=${client_id}&service_id=${service_id}&customer_id=${encodedCallId}&email=${email}&menu=${menu}&submenu=${submenu}&url=${url}${hard_refresh ? '&hard_refresh=1' : ''}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      });
      return resp;
    }
    async getDashboardData(email, client_id){
      let resp = await fetch(`${apiUrl}/api/internal/dashboard/dashboard_data/?client_id=${client_id}&email=${email}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      });
      return resp; 
    }
    async getCallsPageDetails(client_id, service_id, email, menu, submenu, page_number, employee, record_type, time, audioduration, customStart, customEnd, customer_id, score_lower, score_upper, 
      open_concerns, conversation_id, segment_type, segment_id, segment_name, fatal, conversation_potential, conversation_type, agent_feedback_parameter, business_insight_parameter, concern_category, concern_subcategory, query_category, query_subcategory, disposition, subdisposition, conversation_direction=undefined, lead_source=undefined, primary_language=undefined, secondary_languages=undefined, lead_sub_source=undefined, tag=undefined, tag2=undefined, tag3=undefined, tag4=undefined, tag5=undefined, tag6=undefined, tag7=undefined, tag8=undefined, tag9=undefined, tag10=undefined, tag11=undefined, tag12=undefined, tag13=undefined, tag14=undefined, tag15=undefined, tag16=undefined, tag17=undefined, tag18=undefined, tag19=undefined, tag20=undefined, tag21=undefined, tag22=undefined, tag23=undefined, tag24=undefined, tag25=undefined, tag26=undefined, tag27=undefined, tag28=undefined, tag29=undefined, tag30=undefined, campaign_id=undefined, campaign_batch_id=undefined, actor_type=undefined, show_type=undefined, first_proper_conversation=undefined, needs_review=undefined, crm_lead_stage=undefined, crm_lead_sub_stage=undefined, customer_phone_number=undefined, crm_location=undefined, conversation_type_reason=undefined, custom_module_parameter_name=undefined, custom_module_parameter_answer=undefined, abortSignal=undefined, module_parameter_filters=undefined,       crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined, team_name=undefined, customer_outcome=undefined, refusal_category=undefined){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/calls_page_details/`,{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          page_number,
          employee_id: employee,
          record_type,
          call_time: time,
          audio_duration: audioduration,
          custom_start: customStart,
          custom_end: customEnd,
          customer_id,
          score_lower,
          score_upper,
          open_concerns,
          conversation_id,
          segment_type,
          segment_id,
          segment_name,
          show_type,
          fatal,
          conversation_potential,
          conversation_type,
          agent_feedback_parameter,
          business_insight_parameter,
          concern_category,
          concern_subcategory,
          query_category,
          query_subcategory,
          disposition,
          subdisposition,
          conversation_direction,
          lead_source,
          primary_language,
          secondary_languages,
          lead_sub_source,
          tag,
          tag2,
          tag3,
          tag4,
          tag5,
          tag6,
          tag7,
          tag8,
          tag9,
          tag10,
          tag11,
          tag12,
          tag13,
          tag14,
          tag15,
          tag16,
          tag17,
          tag18,
          tag19,
          tag20,
          tag21,
          tag22,
          tag23,
          tag24,
          tag25,
          tag26,
          tag27,
          tag28,
          tag29,
          tag30,
          campaign_id,
          campaign_batch_id,
          actor_type,
          first_proper_conversation,
          needs_review,
          crm_lead_stage,
          crm_lead_sub_stage,
          customer_phone_number,
          crm_location,
          crm_lead_created_at,
          crm_lead_created_at_start,
          crm_lead_created_at_end,
          crm_lead_created_at_range_type,
          team_name,
          customer_outcome,
          refusal_category,
          conversation_type_reason,
          custom_module_parameter_name,
          custom_module_parameter_answer,
          module_parameter_filters
        })),
        credentials: 'include',
        ...(abortSignal ? { signal: abortSignal } : {})
      });
      return resp;
    }
    async getDownloadCallData(client_id, service_id, email, menu, submenu, page_number, employee, record_type, time, audioduration, customStart, customEnd, segment_type, segment_id, segment_name, customer_id, open_concerns, conversation_id, score_lower, score_upper, show_type='downloads', page_size=50, fatal=undefined, conversation_potential=undefined, conversation_type=undefined, agent_feedback_parameter=undefined, business_insight_parameter=undefined, concern_category=undefined, concern_subcategory=undefined, query_category=undefined, query_subcategory=undefined, disposition=undefined, subdisposition=undefined, conversation_direction=undefined, lead_source=undefined, primary_language=undefined, secondary_languages=undefined, lead_sub_source=undefined, tag=undefined, tag2=undefined, tag3=undefined, tag4=undefined, tag5=undefined, tag6=undefined, tag7=undefined, tag8=undefined, tag9=undefined, tag10=undefined, tag11=undefined, tag12=undefined, tag13=undefined, tag14=undefined, tag15=undefined, tag16=undefined, tag17=undefined, tag18=undefined, tag19=undefined, tag20=undefined, tag21=undefined, tag22=undefined, tag23=undefined, tag24=undefined, tag25=undefined, tag26=undefined, tag27=undefined, tag28=undefined, tag29=undefined, tag30=undefined, campaign_id=undefined, campaign_batch_id=undefined, actor_type=undefined, first_proper_conversation=undefined, needs_review=undefined, crm_lead_stage=undefined, crm_lead_sub_stage=undefined, customer_phone_number=undefined, crm_location=undefined, conversation_type_reason=undefined, custom_module_parameter_name=undefined, custom_module_parameter_answer=undefined, abortSignal=undefined, parameters=undefined, perform_download=false, module_parameter_filters=undefined, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined, team_name=undefined, filter_type='quick', conversation_ids=[], customer_ids=[]){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/calls_download/`,{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          page_number,
          page_size,
          employee_id: employee,
          record_type,
          call_time: time,
          audio_duration: audioduration,
          custom_start: customStart,
          custom_end: customEnd,
          customer_id,
          segment_type,
          segment_id,
          segment_name,
          open_concerns,
          conversation_id,
          score_lower,
          score_upper,
          show_type,
          fatal,
          conversation_potential,
          conversation_type,
          agent_feedback_parameter,
          business_insight_parameter,
          concern_category,
          concern_subcategory,
          query_category,
          query_subcategory,
          disposition,
          subdisposition,
          conversation_direction,
          lead_source,
          primary_language,
          secondary_languages,
          lead_sub_source,
          tag,
          tag2,
          tag3,
          tag4,
          tag5,
          tag6,
          tag7,
          tag8,
          tag9,
          tag10,
          tag11,
          tag12,
          tag13,
          tag14,
          tag15,
          tag16,
          tag17,
          tag18,
          tag19,
          tag20,
          tag21,
          tag22,
          tag23,
          tag24,
          tag25,
          tag26,
          tag27,
          tag28,
          tag29,
          tag30,
          campaign_id,
          campaign_batch_id,
          actor_type,
          first_proper_conversation,
          needs_review,
          crm_lead_stage,
          crm_lead_sub_stage,
          customer_phone_number,
          crm_location,
          crm_lead_created_at,
          crm_lead_created_at_start,
          crm_lead_created_at_end,
          crm_lead_created_at_range_type,
          team_name,
          conversation_type_reason,
          custom_module_parameter_name,
          custom_module_parameter_answer,
          parameters,
          perform_download,
          module_parameter_filters,
          filter_type,
          conversation_ids,
          customer_ids
        })),
        credentials: 'include',
        ...(abortSignal ? { signal: abortSignal } : {})
      });
      return resp;
    }
    async getCustomerPageDetails(client_id, service_id, email, menu, submenu, page_number, employee, firstinteraction, id, lastinteraction, interactions, openConcerns, first_interaction_custom_start, first_interaction_custom_end, last_interaction_custom_start, last_interaction_custom_end, segment_type, segment_id, segment_name, customer_potential, business_insight_parameter=null, concern_category=null, concern_subcategory=null, query_category=null, query_subcategory=null, disposition=null, subdisposition=null, lead_source=undefined, primary_language=undefined, secondary_languages=undefined, lead_sub_source=undefined, tag=undefined, tag2=undefined, tag3=undefined, tag4=undefined, tag5=undefined, tag6=undefined, tag7=undefined, tag8=undefined, tag9=undefined, tag10=undefined, tag11=undefined, tag12=undefined, tag13=undefined, tag14=undefined, tag15=undefined, tag16=undefined, tag17=undefined, tag18=undefined, tag19=undefined, tag20=undefined, tag21=undefined, tag22=undefined, tag23=undefined, tag24=undefined, tag25=undefined, tag26=undefined, tag27=undefined, tag28=undefined, tag29=undefined, tag30=undefined, crm_lead_stage=undefined, crm_lead_sub_stage=undefined, customer_phone_number=undefined, crm_location=undefined, campaign_id=undefined, custom_module_parameter_name=undefined, custom_module_parameter_answer=undefined, abortSignal=undefined, module_parameter_filters=undefined, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined, team_name=undefined){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/customer_page_details/`,{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          page_number,
          employee_id: employee,
          first_interaction_time: firstinteraction,
          customer_id: id,
          last_interaction_time: lastinteraction,
          open_concerns: openConcerns,
          interactions,
          first_interaction_custom_start,
          first_interaction_custom_end,
          last_interaction_custom_start,
          last_interaction_custom_end,
          segment_type,
          segment_id,
          segment_name,
          customer_potential,
          business_insight_parameter,
          concern_category,
          concern_subcategory,
          query_category,
          query_subcategory,
          disposition,
          subdisposition,
          lead_source,
          primary_language,
          secondary_languages,
          lead_sub_source,
          tag,
          tag2,
          tag3,
          tag4,
          tag5,
          tag6,
          tag7,
          tag8,
          tag9,
          tag10,
          tag11,
          tag12,
          tag13,
          tag14,
          tag15,
          tag16,
          tag17,
          tag18,
          tag19,
          tag20,
          tag21,
          tag22,
          tag23,
          tag24,
          tag25,
          tag26,
          tag27,
          tag28,
          tag29,
          tag30,
          crm_lead_stage,
          crm_lead_sub_stage,
          customer_phone_number,
          crm_location,
          crm_lead_created_at,
          crm_lead_created_at_start,
          crm_lead_created_at_end,
          crm_lead_created_at_range_type,
          team_name,
          campaign_id,
          custom_module_parameter_name,
          custom_module_parameter_answer,
          module_parameter_filters
        })),
        credentials: 'include',
        ...(abortSignal ? { signal: abortSignal } : {})
      });
      return resp;
    }
    async getDownloadCustomerData(client_id, service_id, email, menu, submenu, page_number, employee, firstinteraction, id, lastinteraction, interactions, openConcerns, first_interaction_custom_start, first_interaction_custom_end, last_interaction_custom_start, last_interaction_custom_end, segment_type, segment_id, segment_name, page_size, customer_potential, business_insight_parameter=null, concern_category=null, concern_subcategory=null, query_category=null, query_subcategory=null, disposition=null, subdisposition=null, lead_source=undefined, primary_language=undefined, secondary_languages=undefined, lead_sub_source=undefined, tag=undefined, tag2=undefined, tag3=undefined, tag4=undefined, tag5=undefined, tag6=undefined, tag7=undefined, tag8=undefined, tag9=undefined, tag10=undefined, tag11=undefined, tag12=undefined, tag13=undefined, tag14=undefined, tag15=undefined, tag16=undefined, tag17=undefined, tag18=undefined, tag19=undefined, tag20=undefined, tag21=undefined, tag22=undefined, tag23=undefined, tag24=undefined, tag25=undefined, tag26=undefined, tag27=undefined, tag28=undefined, tag29=undefined, tag30=undefined, crm_lead_stage=undefined, crm_lead_sub_stage=undefined, customer_phone_number=undefined, crm_location=undefined, campaign_id=undefined, show_type='downloads', custom_module_parameter_name=undefined, custom_module_parameter_answer=undefined, abortSignal=undefined, parameters=undefined, perform_download=false, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined, team_name=undefined, filter_type='quick', customer_ids=[], module_parameter_filters=undefined){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/customers_download/`,{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          page_number,
          page_size,
          employee_id: employee,
          first_interaction_time: firstinteraction,
          customer_id: id,
          last_interaction_time: lastinteraction,
          open_concerns: openConcerns,
          interactions,
          first_interaction_custom_start,
          first_interaction_custom_end,
          last_interaction_custom_start,
          last_interaction_custom_end,
          segment_type,
          segment_id,
          segment_name,
          customer_potential,
          business_insight_parameter,
          concern_category,
          concern_subcategory,
          query_category,
          query_subcategory,
          disposition,
          subdisposition,
          show_type,
          lead_source,
          primary_language,
          secondary_languages,
          lead_sub_source,
          tag,
          tag2,
          tag3,
          tag4,
          tag5,
          tag6,
          tag7,
          tag8,
          tag9,
          tag10,
          tag11,
          tag12,
          tag13,
          tag14,
          tag15,
          tag16,
          tag17,
          tag18,
          tag19,
          tag20,
          tag21,
          tag22,
          tag23,
          tag24,
          tag25,
          tag26,
          tag27,
          tag28,
          tag29,
          tag30,
          crm_lead_stage,
          crm_lead_sub_stage,
          customer_phone_number,
          crm_location,
          crm_lead_created_at,
          crm_lead_created_at_start,
          crm_lead_created_at_end,
          crm_lead_created_at_range_type,
          team_name,
          campaign_id,
          custom_module_parameter_name,
          custom_module_parameter_answer,
          parameters,
          perform_download,
          module_parameter_filters,
          filter_type,
          customer_ids
        })),
        credentials: 'include',
        ...(abortSignal ? { signal: abortSignal } : {})
      });
      return resp;
    }
    /**
     * Voice agents calls download: JSON body is built in the app (see `voiceAgentDownloadPayload.js`).
     * Does not use `buildDashboardFilterPayload` / `filterPayloadBuilder.js`.
     */
    async postVoiceAgentCallsDownloadRequest(body) {
      return await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/calls_download/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
        credentials: 'include',
      });
    }
    /**
     * Voice agents customers download: JSON body is built in the app (see `voiceAgentDownloadPayload.js`).
     * Does not use `buildDashboardFilterPayload` / `filterPayloadBuilder.js`.
     */
    async postVoiceAgentCustomersDownloadRequest(body) {
      return await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/customers_download/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
        credentials: 'include',
      });
    }
    async getTeamMemberSettings(client_id, service_id, email, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/team_member_configure/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}`,{
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      });
      return resp;
    }
    async getOrganizationMetadata(client_id, email, menu = 'organization-settings') {
      const params = new URLSearchParams({ client_id, email, menu });
      return await fetch(`${apiUrl}/api/internal/new_dashboard/organization_metadata/?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });
    }
    async updateOrganizationMetadata(data) {
      return await fetch(`${apiUrl}/api/internal/new_dashboard/organization_metadata/`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ...data, menu: 'organization-settings' }),
        credentials: 'include',
      });
    }
    async postTeamMemberSettings(obj) {
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/team_member_configure/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...obj}),
        credentials: 'include' // Automatically sends the cookies stored from the previous request
      });
      return resp;
    }
    async editTeamMemberSettings(obj) {
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/team_member_configure/edit/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...obj}),
        credentials: 'include' // Automatically sends the cookies stored from the previous request
      });
      return resp;
    }
    async deleteTeamMemberSettings(obj) {
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/team_member_configure/delete/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...obj}),
        credentials: 'include' // Automatically sends the cookies stored from the previous request
      });
      return resp;
    }
    async getProjectMembersSettings(client_id, service_id, email, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/project_configure/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}`,{
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      });
      return resp;
    }
    async postProjectMembersSettings(obj) {
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/project_configure/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...obj}),
        credentials: 'include' // Automatically sends the cookies stored from the previous request
      });
      return resp;
    }
    async editProjectMemberSettings(obj){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/project_configure/edit/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...obj}),
        credentials: 'include' // Automatically sends the cookies stored from the previous request
      });
      return resp;
    }
    async deleteProjectMembersSettings(obj) {
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/project_configure/delete/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...obj}),
        credentials: 'include' // Automatically sends the cookies stored from the previous request
      });
      return resp;
    }
    async getDashboardTeams(client_id, service_id, email, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/project_configure/team_employee_mapping/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}`,{
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      });
      return resp;
    }
    async postDashboardTeam(obj) {
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/project_configure/team_employee_mapping/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...obj}),
        credentials: 'include'
      });
      return resp;
    }
    async getProjectsList(client_id, service_id, email, menu, submenu, role){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/create_projects/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&user_role=${role}`,{
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      });
      return resp;
    }
    async createProject(obj) {
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/create_projects/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...obj}),
        credentials: 'include' // Automatically sends the cookies stored from the previous request
      });
      return resp;
    }
    async defaultModuleStatus(client_id, service_id, email, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/default_module_status/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      });
      return resp;
    }
    async getClientModuleConfig(client_id, service_id, email, menu, submenu, module_name){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/client_module_configuration/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&module_name=${module_name}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      });
      return resp;
    }
    async getPerformanceMetrics(client_id, service_id, email, menu, submenu, employee_id, call_time, audio_duration, custom_start, custom_end, record_type, team_name, customer_id, fatal, open_concerns, conversation_type, conversation_potential, score_lower, score_upper, agent_feedback_parameter, business_insight_parameter, concern_category, concern_subcategory, query_category, query_subcategory, disposition, subdisposition, conversation_direction, lead_source, primary_language, secondary_languages, lead_sub_source, tag, tag2, tag3, tag4, tag5, tag6, tag7, tag8, tag9, tag10, tag11, tag12, tag13, tag14, tag15, tag16, tag17, tag18, tag19, tag20, tag21, tag22, tag23, tag24, tag25, tag26, tag27, tag28, tag29, tag30, campaign_id, actor_type, crm_lead_stage, crm_lead_sub_stage, customer_phone_number, crm_location, conversation_type_reason, first_proper_conversation, custom_module_parameter_name = undefined, custom_module_parameter_answer = undefined, abortSignal=null, module_parameter_filters=undefined, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/agent_feedback/performance_metrics/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          employee_id,
          call_time,
          audio_duration,
          custom_start,
          custom_end,
          record_type,
          customer_id,
          fatal,
          open_concerns,
          conversation_type,
          conversation_potential,
          score_lower,
          score_upper,
          agent_feedback_parameter,
          business_insight_parameter,
          concern_category,
          concern_subcategory,
          query_category,
          query_subcategory,
          disposition,
          subdisposition,
          conversation_direction,
          lead_source,
          primary_language,
          secondary_languages,
          lead_sub_source,
          tag,
          tag2,
          tag3,
          tag4,
          tag5,
          tag6,
          tag7,
          tag8,
          tag9,
          tag10,
          tag11,
          tag12,
          tag13,
          tag14,
          tag15,
          tag16,
          tag17,
          tag18,
          tag19,
          tag20,
          tag21,
          tag22,
          tag23,
          tag24,
          tag25,
          tag26,
          tag27,
          tag28,
          tag29,
          tag30,
          campaign_id,
          actor_type,
          crm_lead_stage,
          crm_lead_sub_stage,
          customer_phone_number,
          crm_location,
          crm_lead_created_at,
          crm_lead_created_at_start,
          crm_lead_created_at_end,
          crm_lead_created_at_range_type,
          team_name: team_name,
          conversation_type_reason,
          first_proper_conversation,
          custom_module_parameter_name,
          custom_module_parameter_answer,
          module_parameter_filters
        })),
        credentials: 'include',
        ...(abortSignal ? { signal: abortSignal } : {})
      });
      return resp;
    }
    async getTeamWisePerformanceMetrics(client_id, service_id, email, menu, submenu, employee_id, call_time, audio_duration, custom_start, custom_end, record_type, customer_id, fatal, open_concerns, conversation_type, conversation_potential, score_lower, score_upper, agent_feedback_parameter, business_insight_parameter, concern_category, concern_subcategory, query_category, query_subcategory, disposition, subdisposition, conversation_direction, lead_source, primary_language, secondary_languages, lead_sub_source, tag, tag2, tag3, tag4, tag5, tag6, tag7, tag8, tag9, tag10, tag11, tag12, tag13, tag14, tag15, tag16, tag17, tag18, tag19, tag20, tag21, tag22, tag23, tag24, tag25, tag26, tag27, tag28, tag29, tag30, campaign_id, actor_type, crm_lead_stage, crm_lead_sub_stage, customer_phone_number, crm_location, conversation_type_reason, first_proper_conversation, custom_module_parameter_name = undefined, custom_module_parameter_answer = undefined, abortSignal=null, module_parameter_filters=undefined, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined, team_name=undefined){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/agent_feedback/team_wise/performance_metrics/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          employee_id,
          call_time,
          audio_duration,
          custom_start,
          custom_end,
          record_type,
          customer_id,
          fatal,
          open_concerns,
          conversation_type,
          conversation_potential,
          score_lower,
          score_upper,
          agent_feedback_parameter,
          business_insight_parameter,
          concern_category,
          concern_subcategory,
          query_category,
          query_subcategory,
          disposition,
          subdisposition,
          conversation_direction,
          lead_source,
          primary_language,
          secondary_languages,
          lead_sub_source,
          tag,
          tag2,
          tag3,
          tag4,
          tag5,
          tag6,
          tag7,
          tag8,
          tag9,
          tag10,
          tag11,
          tag12,
          tag13,
          tag14,
          tag15,
          tag16,
          tag17,
          tag18,
          tag19,
          tag20,
          tag21,
          tag22,
          tag23,
          tag24,
          tag25,
          tag26,
          tag27,
          tag28,
          tag29,
          tag30,
          campaign_id,
          actor_type,
          crm_lead_stage,
          crm_lead_sub_stage,
          customer_phone_number,
          crm_location,
          crm_lead_created_at,
          crm_lead_created_at_start,
          crm_lead_created_at_end,
          crm_lead_created_at_range_type,
          team_name: team_name,
          conversation_type_reason,
          first_proper_conversation,
          custom_module_parameter_name,
          custom_module_parameter_answer,
          module_parameter_filters
        })),
        credentials: 'include',
        ...(abortSignal ? { signal: abortSignal } : {})
      });
      return resp;
    }
    async getCallDistributionAgentFeedback(client_id, service_id, email, menu, submenu, employee_id, call_time, audio_duration, custom_start, custom_end, record_type, customer_id, fatal, open_concerns, conversation_type, conversation_potential, score_lower, score_upper, agent_feedback_parameter, business_insight_parameter, concern_category, concern_subcategory, query_category, query_subcategory, disposition, subdisposition, conversation_direction, lead_source, primary_language, secondary_languages, lead_sub_source, tag, tag2, tag3, tag4, tag5, tag6, tag7, tag8, tag9, tag10, tag11, tag12, tag13, tag14, tag15, tag16, tag17, tag18, tag19, tag20, tag21, tag22, tag23, tag24, tag25, tag26, tag27, tag28, tag29, tag30, campaign_id, actor_type, crm_lead_stage, crm_lead_sub_stage, customer_phone_number, crm_location, conversation_type_reason, first_proper_conversation, custom_module_parameter_name = undefined, custom_module_parameter_answer = undefined, abortSignal=null, module_parameter_filters=undefined, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined, team_name=undefined){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/agent_feedback/call_distribution/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          employee_id,
          call_time,
          audio_duration,
          custom_start,
          custom_end,
          record_type,
          customer_id,
          fatal,
          open_concerns,
          conversation_type,
          conversation_potential,
          score_lower,
          score_upper,
          agent_feedback_parameter,
          business_insight_parameter,
          concern_category,
          concern_subcategory,
          query_category,
          query_subcategory,
          disposition,
          subdisposition,
          conversation_direction,
          lead_source,
          primary_language,
          secondary_languages,
          lead_sub_source,
          tag,
          tag2,
          tag3,
          tag4,
          tag5,
          tag6,
          tag7,
          tag8,
          tag9,
          tag10,
          tag11,
          tag12,
          tag13,
          tag14,
          tag15,
          tag16,
          tag17,
          tag18,
          tag19,
          tag20,
          tag21,
          tag22,
          tag23,
          tag24,
          tag25,
          tag26,
          tag27,
          tag28,
          tag29,
          tag30,
          campaign_id,
          actor_type,
          crm_lead_stage,
          crm_lead_sub_stage,
          customer_phone_number,
          crm_location,
          crm_lead_created_at,
          crm_lead_created_at_start,
          crm_lead_created_at_end,
          crm_lead_created_at_range_type,
          team_name,
          conversation_type_reason,
          first_proper_conversation,
          custom_module_parameter_name,
          custom_module_parameter_answer,
          module_parameter_filters
        })),
        credentials: 'include',
        ...(abortSignal ? { signal: abortSignal } : {})
      });
      return resp;
    }
    async getDailyTrendAgentFeedback(client_id, service_id, email, menu, submenu, employee_id, call_time, audio_duration, custom_start, custom_end, parameters, record_type, customer_id, fatal, open_concerns, conversation_type, conversation_potential, score_lower, score_upper, agent_feedback_parameter, business_insight_parameter, concern_category, concern_subcategory, query_category, query_subcategory, disposition, subdisposition, conversation_direction, lead_source, primary_language, secondary_languages, lead_sub_source, tag, tag2, tag3, tag4, tag5, tag6, tag7, tag8, tag9, tag10, tag11, tag12, tag13, tag14, tag15, tag16, tag17, tag18, tag19, tag20, tag21, tag22, tag23, tag24, tag25, tag26, tag27, tag28, tag29, tag30, campaign_id, actor_type, crm_lead_stage, crm_lead_sub_stage, customer_phone_number, crm_location, conversation_type_reason, first_proper_conversation, custom_module_parameter_name = undefined, custom_module_parameter_answer = undefined, abortSignal=null, module_parameter_filters=undefined, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined, team_name=undefined){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/agent_feedback/daily_trend_distribution/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          employee_id,
          call_time,
          audio_duration,
          parameters,
          custom_start,
          custom_end,
          record_type,
          customer_id,
          fatal,
          open_concerns,
          conversation_type,
          conversation_potential,
          score_lower,
          score_upper,
          agent_feedback_parameter,
          business_insight_parameter,
          concern_category,
          concern_subcategory,
          query_category,
          query_subcategory,
          disposition,
          subdisposition,
          conversation_direction,
          lead_source,
          primary_language,
          secondary_languages,
          lead_sub_source,
          tag,
          tag2,
          tag3,
          tag4,
          tag5,
          tag6,
          tag7,
          tag8,
          tag9,
          tag10,
          tag11,
          tag12,
          tag13,
          tag14,
          tag15,
          tag16,
          tag17,
          tag18,
          tag19,
          tag20,
          tag21,
          tag22,
          tag23,
          tag24,
          tag25,
          tag26,
          tag27,
          tag28,
          tag29,
          tag30,
          campaign_id,
          actor_type,
          crm_lead_stage,
          crm_lead_sub_stage,
          customer_phone_number,
          crm_location,
          crm_lead_created_at,
          crm_lead_created_at_start,
          crm_lead_created_at_end,
          crm_lead_created_at_range_type,
          team_name,
          conversation_type_reason,
          first_proper_conversation,
          custom_module_parameter_name,
          custom_module_parameter_answer,
          module_parameter_filters
        })),
        credentials: 'include',
        ...(abortSignal ? { signal: abortSignal } : {})
      });
      return resp;
    }
    async getPerformers(client_id, service_id, email, menu, submenu, employee_id, call_time, audio_duration,custom_start, custom_end, record_type, type, team_name, customer_id, fatal, open_concerns, conversation_type, conversation_potential, score_lower, score_upper, agent_feedback_parameter, business_insight_parameter, concern_category, concern_subcategory, query_category, query_subcategory, disposition, subdisposition, conversation_direction, lead_source, primary_language, secondary_languages, lead_sub_source, tag, tag2, tag3, tag4, tag5, tag6, tag7, tag8, tag9, tag10, tag11, tag12, tag13, tag14, tag15, tag16, tag17, tag18, tag19, tag20, tag21, tag22, tag23, tag24, tag25, tag26, tag27, tag28, tag29, tag30, campaign_id, actor_type, crm_lead_stage, crm_lead_sub_stage, customer_phone_number, crm_location, conversation_type_reason, first_proper_conversation, custom_module_parameter_name = undefined, custom_module_parameter_answer = undefined, abortSignal=null, module_parameter_filters=undefined, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/agent_feedback/performers/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          employee_id,
          call_time,
          audio_duration,
          type,
          custom_start,
          custom_end,
          record_type,
          customer_id,
          fatal,
          open_concerns,
          conversation_type,
          conversation_potential,
          score_lower,
          score_upper,
          agent_feedback_parameter,
          business_insight_parameter,
          concern_category,
          concern_subcategory,
          query_category,
          query_subcategory,
          disposition,
          subdisposition,
          conversation_direction,
          lead_source,
          primary_language,
          secondary_languages,
          lead_sub_source,
          tag,
          tag2,
          tag3,
          tag4,
          tag5,
          tag6,
          tag7,
          tag8,
          tag9,
          tag10,
          tag11,
          tag12,
          tag13,
          tag14,
          tag15,
          tag16,
          tag17,
          tag18,
          tag19,
          tag20,
          tag21,
          tag22,
          tag23,
          tag24,
          tag25,
          tag26,
          tag27,
          tag28,
          tag29,
          tag30,
          campaign_id,
          actor_type,
          crm_lead_stage,
          crm_lead_sub_stage,
          customer_phone_number,
          crm_location,
          crm_lead_created_at,
          crm_lead_created_at_start,
          crm_lead_created_at_end,
          crm_lead_created_at_range_type,
          team_name,
          conversation_type_reason,
          first_proper_conversation,
          custom_module_parameter_name,
          custom_module_parameter_answer,
          module_parameter_filters
        })),
        credentials: 'include',
        ...(abortSignal ? { signal: abortSignal } : {})
      });
      return resp;
    }
    async getParameters(client_id, service_id, email, menu, submenu, employee_id, call_time, audio_duration,custom_start, custom_end, record_type, type, team_name, customer_id, fatal, open_concerns, conversation_type, conversation_potential, score_lower, score_upper, agent_feedback_parameter, business_insight_parameter, concern_category, concern_subcategory, query_category, query_subcategory, disposition, subdisposition, conversation_direction, lead_source, primary_language, secondary_languages, lead_sub_source, tag, tag2, tag3, tag4, tag5, tag6, tag7, tag8, tag9, tag10, tag11, tag12, tag13, tag14, tag15, tag16, tag17, tag18, tag19, tag20, tag21, tag22, tag23, tag24, tag25, tag26, tag27, tag28, tag29, tag30, campaign_id, actor_type, crm_lead_stage, crm_lead_sub_stage, customer_phone_number, crm_location, conversation_type_reason, first_proper_conversation, custom_module_parameter_name = undefined, custom_module_parameter_answer = undefined, abortSignal=null, module_parameter_filters=undefined, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/agent_feedback/parameters/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          employee_id,
          call_time,
          audio_duration,
          type,
          custom_start,
          custom_end,
          record_type,
          customer_id,
          fatal,
          open_concerns,
          conversation_type,
          conversation_potential,
          score_lower,
          score_upper,
          agent_feedback_parameter,
          business_insight_parameter,
          concern_category,
          concern_subcategory,
          query_category,
          query_subcategory,
          disposition,
          subdisposition,
          conversation_direction,
          lead_source,
          primary_language,
          secondary_languages,
          lead_sub_source,
          tag,
          tag2,
          tag3,
          tag4,
          tag5,
          tag6,
          tag7,
          tag8,
          tag9,
          tag10,
          tag11,
          tag12,
          tag13,
          tag14,
          tag15,
          tag16,
          tag17,
          tag18,
          tag19,
          tag20,
          tag21,
          tag22,
          tag23,
          tag24,
          tag25,
          tag26,
          tag27,
          tag28,
          tag29,
          tag30,
          campaign_id,
          actor_type,
          crm_lead_stage,
          crm_lead_sub_stage,
          customer_phone_number,
          crm_location,
          crm_lead_created_at,
          crm_lead_created_at_start,
          crm_lead_created_at_end,
          crm_lead_created_at_range_type,
          team_name,
          conversation_type_reason,
          first_proper_conversation,
          custom_module_parameter_name,
          custom_module_parameter_answer,
          module_parameter_filters
        })),
        credentials: 'include',
        ...(abortSignal ? { signal: abortSignal } : {})
      });
      return resp;
    }
    async getDetailedCompetencyScores(client_id, service_id, email, menu, submenu, employee_id, call_time, audio_duration,custom_start, custom_end, record_type, customer_id, fatal, open_concerns, conversation_type, conversation_potential, score_lower, score_upper, agent_feedback_parameter, business_insight_parameter, concern_category, concern_subcategory, query_category, query_subcategory, disposition, subdisposition, conversation_direction, lead_source, primary_language, secondary_languages, lead_sub_source, tag, tag2, tag3, tag4, tag5, tag6, tag7, tag8, tag9, tag10, tag11, tag12, tag13, tag14, tag15, tag16, tag17, tag18, tag19, tag20, tag21, tag22, tag23, tag24, tag25, tag26, tag27, tag28, tag29, tag30, campaign_id, actor_type, crm_lead_stage, crm_lead_sub_stage, customer_phone_number, crm_location, conversation_type_reason, first_proper_conversation, custom_module_parameter_name = undefined, custom_module_parameter_answer = undefined, abortSignal=null, module_parameter_filters=undefined, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined, team_name=undefined){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/agent_feedback/detailed_competency_scores/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          employee_id,
          call_time,
          audio_duration,
          custom_start,
          custom_end,
          record_type,
          customer_id,
          fatal,
          open_concerns,
          conversation_type,
          conversation_potential,
          score_lower,
          score_upper,
          agent_feedback_parameter,
          business_insight_parameter,
          concern_category,
          concern_subcategory,
          query_category,
          query_subcategory,
          disposition,
          subdisposition,
          conversation_direction,
          lead_source,
          primary_language,
          secondary_languages,
          lead_sub_source,
          tag,
          tag2,
          tag3,
          tag4,
          tag5,
          tag6,
          tag7,
          tag8,
          tag9,
          tag10,
          tag11,
          tag12,
          tag13,
          tag14,
          tag15,
          tag16,
          tag17,
          tag18,
          tag19,
          tag20,
          tag21,
          tag22,
          tag23,
          tag24,
          tag25,
          tag26,
          tag27,
          tag28,
          tag29,
          tag30,
          campaign_id,
          actor_type,
          crm_lead_stage,
          crm_lead_sub_stage,
          customer_phone_number,
          crm_location,
          crm_lead_created_at,
          crm_lead_created_at_start,
          crm_lead_created_at_end,
          crm_lead_created_at_range_type,
          team_name,
          conversation_type_reason,
          first_proper_conversation,
          custom_module_parameter_name,
          custom_module_parameter_answer,
          module_parameter_filters
        })),
        credentials: 'include',
        ...(abortSignal ? { signal: abortSignal } : {})
      });
      return resp;
    }
    async getTeamWiseDetailedCompetencyScores(client_id, service_id, email, menu, submenu, employee_id, call_time, audio_duration,custom_start, custom_end, record_type, customer_id, fatal, open_concerns, conversation_type, conversation_potential, score_lower, score_upper, agent_feedback_parameter, business_insight_parameter, concern_category, concern_subcategory, query_category, query_subcategory, disposition, subdisposition, conversation_direction, lead_source, primary_language, secondary_languages, lead_sub_source, tag, tag2, tag3, tag4, tag5, tag6, tag7, tag8, tag9, tag10, tag11, tag12, tag13, tag14, tag15, tag16, tag17, tag18, tag19, tag20, tag21, tag22, tag23, tag24, tag25, tag26, tag27, tag28, tag29, tag30, campaign_id, actor_type, crm_lead_stage, crm_lead_sub_stage, customer_phone_number, crm_location, conversation_type_reason, first_proper_conversation, custom_module_parameter_name = undefined, custom_module_parameter_answer = undefined, abortSignal=null, module_parameter_filters=undefined, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined, team_name=undefined){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/agent_feedback/team_wise/detailed_competency_scores/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          employee_id,
          call_time,
          audio_duration,
          custom_start,
          custom_end,
          record_type,
          customer_id,
          fatal,
          open_concerns,
          conversation_type,
          conversation_potential,
          score_lower,
          score_upper,
          agent_feedback_parameter,
          business_insight_parameter,
          concern_category,
          concern_subcategory,
          query_category,
          query_subcategory,
          disposition,
          subdisposition,
          conversation_direction,
          lead_source,
          primary_language,
          secondary_languages,
          lead_sub_source,
          tag,
          tag2,
          tag3,
          tag4,
          tag5,
          tag6,
          tag7,
          tag8,
          tag9,
          tag10,
          tag11,
          tag12,
          tag13,
          tag14,
          tag15,
          tag16,
          tag17,
          tag18,
          tag19,
          tag20,
          tag21,
          tag22,
          tag23,
          tag24,
          tag25,
          tag26,
          tag27,
          tag28,
          tag29,
          tag30,
          campaign_id,
          actor_type,
          crm_lead_stage,
          crm_lead_sub_stage,
          customer_phone_number,
          crm_location,
          crm_lead_created_at,
          crm_lead_created_at_start,
          crm_lead_created_at_end,
          crm_lead_created_at_range_type,
          team_name,
          conversation_type_reason,
          first_proper_conversation,
          custom_module_parameter_name,
          custom_module_parameter_answer,
          module_parameter_filters
        })),
        credentials: 'include',
        ...(abortSignal ? { signal: abortSignal } : {})
      });
      return resp;
    }
    async getAdvancedFilterDetailsAgentFeedback(client_id, service_id, email, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/agent_feedback/calls_filter_details/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ client_id, service_id, email, menu, submenu }),
        credentials: 'include'
      });
      return resp;
    }
    async getCustomerFilters(client_id, service_id, email, menu, submenu, signal=null){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/agent_feedback/customer_filter_details/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ client_id, service_id, email, menu, submenu }),
        credentials: 'include',
        ...(signal ? { signal } : {})
      });
      return resp;
    }
    async getDispositionDistribution(client_id, service_id, email, menu, submenu, customer_id, customer_potential, interactions, open_concerns, employee_id, last_interaction_time, first_interaction_time, last_interaction_custom_start, last_interaction_custom_end, first_interaction_custom_start, first_interaction_custom_end, record_type=null, team_name=null, business_insight_parameter=null, concern_category=null, concern_subcategory=null, query_category=null, query_subcategory=null, disposition=null, subdisposition=null, lead_source=null, primary_language=null, secondary_languages=null, lead_sub_source=null, tag=null, tag2=null, tag3=null, tag4=null, tag5=null, tag6=null, tag7=null, tag8=null, tag9=null, tag10=null, tag11=null, tag12=null, tag13=null, tag14=null, tag15=null, tag16=null, tag17=null, tag18=null, tag19=null, tag20=null, tag21=null, tag22=null, tag23=null, tag24=null, tag25=null, tag26=null, tag27=null, tag28=null, tag29=null, tag30=null, crm_lead_stage=undefined, crm_lead_sub_stage=undefined, customer_phone_number=undefined, crm_location=undefined, campaign_id=undefined, custom_module_parameter_name=undefined, custom_module_parameter_answer=undefined, signal=null, module_parameter_filters=undefined, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined){
      const isHomeTeamOnlyArg = menu === 'home' && business_insight_parameter !== null && concern_category === null;
      const effectiveBusinessInsightParameter = isHomeTeamOnlyArg ? null : business_insight_parameter;
      const effectiveTeamName = isHomeTeamOnlyArg ? business_insight_parameter : team_name;
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/business_insight/disposition_distribution/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          customer_id,
          customer_potential,
          interactions,
          open_concerns,
          employee_id,
          last_interaction_time,
          first_interaction_time,
          last_interaction_custom_start,
          last_interaction_custom_end,
          first_interaction_custom_start,
          first_interaction_custom_end,
          record_type,
          business_insight_parameter: effectiveBusinessInsightParameter,
          concern_category,
          concern_subcategory,
          query_category,
          query_subcategory,
          disposition,
          subdisposition,
          lead_source,
          primary_language,
          secondary_languages,
          lead_sub_source,
          tag,
          tag2,
          tag3,
          tag4,
          tag5,
          tag6,
          tag7,
          tag8,
          tag9,
          tag10,
          tag11,
          tag12,
          tag13,
          tag14,
          tag15,
          tag16,
          tag17,
          tag18,
          tag19,
          tag20,
          tag21,
          tag22,
          tag23,
          tag24,
          tag25,
          tag26,
          tag27,
          tag28,
          tag29,
          tag30,
          crm_lead_stage,
          crm_lead_sub_stage,
          customer_phone_number,
          crm_location,
          campaign_id,
          crm_lead_created_at,
          crm_lead_created_at_start,
          crm_lead_created_at_end,
          crm_lead_created_at_range_type,
          team_name: effectiveTeamName,
          custom_module_parameter_name,
          custom_module_parameter_answer,
          module_parameter_filters
        })),
        credentials: 'include',
        ...(signal ? { signal } : {})
      });
      return resp;
    }
    async getPieDistribution(client_id, service_id, email, menu, submenu, customer_id, customer_potential, interactions, open_concerns, employee_id, last_interaction_time, first_interaction_time, last_interaction_custom_start, last_interaction_custom_end, first_interaction_custom_start, first_interaction_custom_end, business_insight_parameter=null, concern_category=null, concern_subcategory=null, query_category=null, query_subcategory=null, disposition=null, subdisposition=null, lead_source=null, primary_language=null, secondary_languages=null, lead_sub_source=null, tag=null, tag2=null, tag3=null, tag4=null, tag5=null, tag6=null, tag7=null, tag8=null, tag9=null, tag10=null, tag11=null, tag12=null, tag13=null, tag14=null, tag15=null, tag16=null, tag17=null, tag18=null, tag19=null, tag20=null, tag21=null, tag22=null, tag23=null, tag24=null, tag25=null, tag26=null, tag27=null, tag28=null, tag29=null, tag30=null, crm_lead_stage=undefined, crm_lead_sub_stage=undefined, customer_phone_number=undefined, crm_location=undefined, campaign_id=undefined, custom_module_parameter_name=undefined, custom_module_parameter_answer=undefined, signal=null, module_parameter_filters=undefined, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined, team_name=undefined){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/business_insight/pie_data_distribution/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          customer_id,
          customer_potential,
          interactions,
          open_concerns,
          employee_id,
          last_interaction_time,
          first_interaction_time,
          last_interaction_custom_start,
          last_interaction_custom_end,
          first_interaction_custom_start,
          first_interaction_custom_end,
          business_insight_parameter,
          concern_category,
          concern_subcategory,
          query_category,
          query_subcategory,
          disposition,
          subdisposition,
          lead_source,
          primary_language,
          secondary_languages,
          lead_sub_source,
          tag,
          tag2,
          tag3,
          tag4,
          tag5,
          tag6,
          tag7,
          tag8,
          tag9,
          tag10,
          tag11,
          tag12,
          tag13,
          tag14,
          tag15,
          tag16,
          tag17,
          tag18,
          tag19,
          tag20,
          tag21,
          tag22,
          tag23,
          tag24,
          tag25,
          tag26,
          tag27,
          tag28,
          tag29,
          tag30,
          crm_lead_stage,
          crm_lead_sub_stage,
          customer_phone_number,
          crm_location,
          campaign_id,
          crm_lead_created_at,
          crm_lead_created_at_start,
          crm_lead_created_at_end,
          crm_lead_created_at_range_type,
          team_name,
          custom_module_parameter_name,
          custom_module_parameter_answer,
          module_parameter_filters
        })),
        credentials: 'include',
        ...(signal ? { signal } : {})
      });
      return resp;
    }
    async getLeadQualityData(client_id, service_id, email, menu, submenu, customer_id, customer_potential, interactions, open_concerns, employee_id, last_interaction_time, first_interaction_time, last_interaction_custom_start, last_interaction_custom_end, first_interaction_custom_start, first_interaction_custom_end, business_insight_parameter=null, concern_category=null, concern_subcategory=null, query_category=null, query_subcategory=null, disposition=null, subdisposition=null, lead_source=null, primary_language=null, secondary_languages=null, lead_sub_source=null, tag=null, tag2=null, tag3=null, tag4=null, tag5=null, tag6=null, tag7=null, tag8=null, tag9=null, tag10=null, tag11=null, tag12=null, tag13=null, tag14=null, tag15=null, tag16=null, tag17=null, tag18=null, tag19=null, tag20=null, tag21=null, tag22=null, tag23=null, tag24=null, tag25=null, tag26=null, tag27=null, tag28=null, tag29=null, tag30=null, crm_lead_stage=undefined, crm_lead_sub_stage=undefined, customer_phone_number=undefined, crm_location=undefined, campaign_id=undefined, custom_module_parameter_name=undefined, custom_module_parameter_answer=undefined, signal=null, module_parameter_filters=undefined, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined, team_name=undefined){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/business_insight/lead_quality/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          customer_id,
          customer_potential,
          interactions,
          open_concerns,
          employee_id,
          last_interaction_time,
          first_interaction_time,
          last_interaction_custom_start,
          last_interaction_custom_end,
          first_interaction_custom_start,
          first_interaction_custom_end,
          business_insight_parameter,
          concern_category,
          concern_subcategory,
          query_category,
          query_subcategory,
          disposition,
          subdisposition,
          lead_source,
          primary_language,
          secondary_languages,
          lead_sub_source,
          tag,
          tag2,
          tag3,
          tag4,
          tag5,
          tag6,
          tag7,
          tag8,
          tag9,
          tag10,
          tag11,
          tag12,
          tag13,
          tag14,
          tag15,
          tag16,
          tag17,
          tag18,
          tag19,
          tag20,
          tag21,
          tag22,
          tag23,
          tag24,
          tag25,
          tag26,
          tag27,
          tag28,
          tag29,
          tag30,
          crm_lead_stage,
          crm_lead_sub_stage,
          customer_phone_number,
          crm_location,
          campaign_id,
          crm_lead_created_at,
          crm_lead_created_at_start,
          crm_lead_created_at_end,
          crm_lead_created_at_range_type,
          team_name,
          custom_module_parameter_name,
          custom_module_parameter_answer,
          module_parameter_filters
        })),
        credentials: 'include',
        ...(signal ? { signal } : {})
      });
      return resp;
    }
    async getCustomModuleAnalytics(client_id, service_id, email, menu, submenu, id, customer_potential, interactions, open_concerns, employee, lastinteraction, firstinteraction, last_custom_start, last_custom_end, first_custom_start, first_custom_end, business_insight_parameter=null, concern_category=null, concern_subcategory=null, query_category=null, query_subcategory=null, disposition=null, subdisposition=null, lead_source=null, primary_language=null, secondary_languages=null, lead_sub_source=null, tag=null, tag2=null, tag3=null, tag4=null, tag5=null, tag6=null, tag7=null, tag8=null, tag9=null, tag10=null, tag11=null, tag12=null, tag13=null, tag14=null, tag15=null, tag16=null, tag17=null, tag18=null, tag19=null, tag20=null, tag21=null, tag22=null, tag23=null, tag24=null, tag25=null, tag26=null, tag27=null, tag28=null, tag29=null, tag30=null, crm_lead_stage=undefined, crm_lead_sub_stage=undefined, customer_phone_number=undefined, crm_location=undefined, campaign_id=undefined, custom_module_parameter_name=undefined, custom_module_parameter_answer=undefined, signal=null, module_parameter_filters=undefined, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined, team_name=undefined){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/custom_module/analytics/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          customer_id: id || '',
          customer_potential: customer_potential || '',
          interactions: interactions || '',
          open_concerns: open_concerns || '',
          employee_id: employee || '',
          last_interaction_time: lastinteraction || '',
          first_interaction_time: firstinteraction || '',
          last_interaction_custom_start: last_custom_start || '',
          last_interaction_custom_end: last_custom_end || '',
          first_interaction_custom_start: first_custom_start || '',
          first_interaction_custom_end: first_custom_end || '',
          custom_module_parameter_name: custom_module_parameter_name || '',
          custom_module_parameter_answer: custom_module_parameter_answer || '',
          business_insight_parameter: business_insight_parameter || '',
          concern_category: concern_category || '',
          concern_subcategory: concern_subcategory || '',
          query_category: query_category || '',
          query_subcategory: query_subcategory || '',
          disposition: disposition || '',
          subdisposition: subdisposition || '',
          lead_source: lead_source || '',
          lead_sub_source: lead_sub_source || '',
          primary_language: primary_language || '',
          secondary_languages: secondary_languages || '',
          tag: tag || '',
          tag2: tag2 || '',
          tag3: tag3 || '',
          tag4: tag4 || '',
          tag5: tag5 || '',
          tag6: tag6 || '',
          tag7: tag7 || '',
          tag8: tag8 || '',
          tag9: tag9 || '',
          tag10: tag10 || '',
          tag11: tag11 || '',
          tag12: tag12 || '',
          tag13: tag13 || '',
          tag14: tag14 || '',
          tag15: tag15 || '',
          tag16: tag16 || '',
          tag17: tag17 || '',
          tag18: tag18 || '',
          tag19: tag19 || '',
          tag20: tag20 || '',
          tag21: tag21 || '',
          tag22: tag22 || '',
          tag23: tag23 || '',
          tag24: tag24 || '',
          tag25: tag25 || '',
          tag26: tag26 || '',
          tag27: tag27 || '',
          tag28: tag28 || '',
          tag29: tag29 || '',
          tag30: tag30 || '',
          crm_lead_stage: crm_lead_stage || '',
          crm_lead_sub_stage: crm_lead_sub_stage || '',
          customer_phone_number: customer_phone_number || '',
          crm_location: crm_location || '',
          campaign_id: campaign_id || '',
          crm_lead_created_at: crm_lead_created_at || '',
          crm_lead_created_at_start: crm_lead_created_at_start || '',
          crm_lead_created_at_end: crm_lead_created_at_end || '',
          team_name: team_name || '',
          module_parameter_filters
        })),
        credentials: 'include',
        ...(signal ? { signal } : {})
      });
      return resp;
    }
    async getFirstResponseTimeAgentWise(client_id, service_id, email, menu, submenu, id, customer_potential, interactions, open_concerns, employee, lastinteraction, firstinteraction, last_custom_start, last_custom_end, first_custom_start, first_custom_end, business_insight_parameter=null, concern_category=null, concern_subcategory=null, query_category=null, query_subcategory=null, disposition=null, subdisposition=null, lead_source=null, primary_language=null, secondary_languages=null, lead_sub_source=null, tag=null, tag2=null, tag3=null, tag4=null, tag5=null, tag6=null, tag7=null, tag8=null, tag9=null, tag10=null, tag11=null, tag12=null, tag13=null, tag14=null, tag15=null, tag16=null, tag17=null, tag18=null, tag19=null, tag20=null, tag21=null, tag22=null, tag23=null, tag24=null, tag25=null, tag26=null, tag27=null, tag28=null, tag29=null, tag30=null, crm_lead_stage=undefined, crm_lead_sub_stage=undefined, customer_phone_number=undefined, crm_location=undefined, campaign_id=undefined, custom_module_parameter_name=undefined, custom_module_parameter_answer=undefined, signal=null, module_parameter_filters=undefined, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined, team_name=undefined){
      return this.getFirstResponseTimeAnalytics(
        'agent_wise',
        client_id, service_id, email, menu, submenu, id, customer_potential, interactions, open_concerns, employee, lastinteraction, firstinteraction, last_custom_start, last_custom_end, first_custom_start, first_custom_end, business_insight_parameter, concern_category, concern_subcategory, query_category, query_subcategory, disposition, subdisposition, lead_source, primary_language, secondary_languages, lead_sub_source, tag, tag2, tag3, tag4, tag5, tag6, tag7, tag8, tag9, tag10, tag11, tag12, tag13, tag14, tag15, tag16, tag17, tag18, tag19, tag20, tag21, tag22, tag23, tag24, tag25, tag26, tag27, tag28, tag29, tag30, crm_lead_stage, crm_lead_sub_stage, customer_phone_number, crm_location, campaign_id, custom_module_parameter_name, custom_module_parameter_answer, signal, module_parameter_filters, crm_lead_created_at, crm_lead_created_at_start, crm_lead_created_at_end, crm_lead_created_at_range_type, team_name
      );
    }
    async getFirstResponseTimeDailyTrend(client_id, service_id, email, menu, submenu, id, customer_potential, interactions, open_concerns, employee, lastinteraction, firstinteraction, last_custom_start, last_custom_end, first_custom_start, first_custom_end, business_insight_parameter=null, concern_category=null, concern_subcategory=null, query_category=null, query_subcategory=null, disposition=null, subdisposition=null, lead_source=null, primary_language=null, secondary_languages=null, lead_sub_source=null, tag=null, tag2=null, tag3=null, tag4=null, tag5=null, tag6=null, tag7=null, tag8=null, tag9=null, tag10=null, tag11=null, tag12=null, tag13=null, tag14=null, tag15=null, tag16=null, tag17=null, tag18=null, tag19=null, tag20=null, tag21=null, tag22=null, tag23=null, tag24=null, tag25=null, tag26=null, tag27=null, tag28=null, tag29=null, tag30=null, crm_lead_stage=undefined, crm_lead_sub_stage=undefined, customer_phone_number=undefined, crm_location=undefined, campaign_id=undefined, custom_module_parameter_name=undefined, custom_module_parameter_answer=undefined, signal=null, module_parameter_filters=undefined, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined, team_name=undefined){
      return this.getFirstResponseTimeAnalytics(
        'daily_trend_distribution',
        client_id, service_id, email, menu, submenu, id, customer_potential, interactions, open_concerns, employee, lastinteraction, firstinteraction, last_custom_start, last_custom_end, first_custom_start, first_custom_end, business_insight_parameter, concern_category, concern_subcategory, query_category, query_subcategory, disposition, subdisposition, lead_source, primary_language, secondary_languages, lead_sub_source, tag, tag2, tag3, tag4, tag5, tag6, tag7, tag8, tag9, tag10, tag11, tag12, tag13, tag14, tag15, tag16, tag17, tag18, tag19, tag20, tag21, tag22, tag23, tag24, tag25, tag26, tag27, tag28, tag29, tag30, crm_lead_stage, crm_lead_sub_stage, customer_phone_number, crm_location, campaign_id, custom_module_parameter_name, custom_module_parameter_answer, signal, module_parameter_filters, crm_lead_created_at, crm_lead_created_at_start, crm_lead_created_at_end, crm_lead_created_at_range_type, team_name
      );
    }
    async getFirstResponseTimePerformanceMetrics(client_id, service_id, email, menu, submenu, id, customer_potential, interactions, open_concerns, employee, lastinteraction, firstinteraction, last_custom_start, last_custom_end, first_custom_start, first_custom_end, business_insight_parameter=null, concern_category=null, concern_subcategory=null, query_category=null, query_subcategory=null, disposition=null, subdisposition=null, lead_source=null, primary_language=null, secondary_languages=null, lead_sub_source=null, tag=null, tag2=null, tag3=null, tag4=null, tag5=null, tag6=null, tag7=null, tag8=null, tag9=null, tag10=null, tag11=null, tag12=null, tag13=null, tag14=null, tag15=null, tag16=null, tag17=null, tag18=null, tag19=null, tag20=null, tag21=null, tag22=null, tag23=null, tag24=null, tag25=null, tag26=null, tag27=null, tag28=null, tag29=null, tag30=null, crm_lead_stage=undefined, crm_lead_sub_stage=undefined, customer_phone_number=undefined, crm_location=undefined, campaign_id=undefined, custom_module_parameter_name=undefined, custom_module_parameter_answer=undefined, signal=null, module_parameter_filters=undefined, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined, team_name=undefined){
      return this.getFirstResponseTimeAnalytics(
        'performance_metrics',
        client_id, service_id, email, menu, submenu, id, customer_potential, interactions, open_concerns, employee, lastinteraction, firstinteraction, last_custom_start, last_custom_end, first_custom_start, first_custom_end, business_insight_parameter, concern_category, concern_subcategory, query_category, query_subcategory, disposition, subdisposition, lead_source, primary_language, secondary_languages, lead_sub_source, tag, tag2, tag3, tag4, tag5, tag6, tag7, tag8, tag9, tag10, tag11, tag12, tag13, tag14, tag15, tag16, tag17, tag18, tag19, tag20, tag21, tag22, tag23, tag24, tag25, tag26, tag27, tag28, tag29, tag30, crm_lead_stage, crm_lead_sub_stage, customer_phone_number, crm_location, campaign_id, custom_module_parameter_name, custom_module_parameter_answer, signal, module_parameter_filters, crm_lead_created_at, crm_lead_created_at_start, crm_lead_created_at_end, crm_lead_created_at_range_type, team_name
      );
    }
    async getFirstResponseTimeAnalytics(report_type, client_id, service_id, email, menu, submenu, id, customer_potential, interactions, open_concerns, employee, lastinteraction, firstinteraction, last_custom_start, last_custom_end, first_custom_start, first_custom_end, business_insight_parameter=null, concern_category=null, concern_subcategory=null, query_category=null, query_subcategory=null, disposition=null, subdisposition=null, lead_source=null, primary_language=null, secondary_languages=null, lead_sub_source=null, tag=null, tag2=null, tag3=null, tag4=null, tag5=null, tag6=null, tag7=null, tag8=null, tag9=null, tag10=null, tag11=null, tag12=null, tag13=null, tag14=null, tag15=null, tag16=null, tag17=null, tag18=null, tag19=null, tag20=null, tag21=null, tag22=null, tag23=null, tag24=null, tag25=null, tag26=null, tag27=null, tag28=null, tag29=null, tag30=null, crm_lead_stage=undefined, crm_lead_sub_stage=undefined, customer_phone_number=undefined, crm_location=undefined, campaign_id=undefined, custom_module_parameter_name=undefined, custom_module_parameter_answer=undefined, signal=null, module_parameter_filters=undefined, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined, team_name=undefined){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/first_response_time/${report_type}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          customer_id: id || '',
          customer_potential: customer_potential || '',
          interactions: interactions || '',
          open_concerns: open_concerns || '',
          employee_id: employee || '',
          last_interaction_time: lastinteraction || '',
          first_interaction_time: firstinteraction || '',
          last_interaction_custom_start: last_custom_start || '',
          last_interaction_custom_end: last_custom_end || '',
          first_interaction_custom_start: first_custom_start || '',
          first_interaction_custom_end: first_custom_end || '',
          custom_module_parameter_name: custom_module_parameter_name || '',
          custom_module_parameter_answer: custom_module_parameter_answer || '',
          business_insight_parameter: business_insight_parameter || '',
          concern_category: concern_category || '',
          concern_subcategory: concern_subcategory || '',
          query_category: query_category || '',
          query_subcategory: query_subcategory || '',
          disposition: disposition || '',
          subdisposition: subdisposition || '',
          lead_source: lead_source || '',
          lead_sub_source: lead_sub_source || '',
          primary_language: primary_language || '',
          secondary_languages: secondary_languages || '',
          tag: tag || '',
          tag2: tag2 || '',
          tag3: tag3 || '',
          tag4: tag4 || '',
          tag5: tag5 || '',
          tag6: tag6 || '',
          tag7: tag7 || '',
          tag8: tag8 || '',
          tag9: tag9 || '',
          tag10: tag10 || '',
          tag11: tag11 || '',
          tag12: tag12 || '',
          tag13: tag13 || '',
          tag14: tag14 || '',
          tag15: tag15 || '',
          tag16: tag16 || '',
          tag17: tag17 || '',
          tag18: tag18 || '',
          tag19: tag19 || '',
          tag20: tag20 || '',
          tag21: tag21 || '',
          tag22: tag22 || '',
          tag23: tag23 || '',
          tag24: tag24 || '',
          tag25: tag25 || '',
          tag26: tag26 || '',
          tag27: tag27 || '',
          tag28: tag28 || '',
          tag29: tag29 || '',
          tag30: tag30 || '',
          crm_lead_stage: crm_lead_stage || '',
          crm_lead_sub_stage: crm_lead_sub_stage || '',
          customer_phone_number: customer_phone_number || '',
          crm_location: crm_location || '',
          campaign_id: campaign_id || '',
          crm_lead_created_at: crm_lead_created_at || '',
          crm_lead_created_at_start: crm_lead_created_at_start || '',
          crm_lead_created_at_end: crm_lead_created_at_end || '',
          crm_lead_created_at_range_type: crm_lead_created_at_range_type || '',
          team_name: team_name || '',
          module_parameter_filters
        })),
        credentials: 'include',
        ...(signal ? { signal } : {})
      });
      return resp;
    }
    async getConcernQueryMetrics(client_id, service_id, email, menu, submenu, employee_id, call_time, custom_start, custom_end, team_name=undefined, abortSignal=null){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/concern_query/metrics/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          employee_id,
          last_interaction_time: call_time,
          last_interaction_custom_start: custom_start,
          last_interaction_custom_end: custom_end,
          team_name
        })),
        credentials: 'include',
        ...(abortSignal ? { signal: abortSignal } : {})
      });
      return resp;
    }
    async getDailyTrendConcernQuery(client_id, service_id, email, menu, submenu, employee_id, parameters, team_name=undefined, abortSignal=null){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/concern_query/daily_trend_distribution/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          employee_id,
          parameters,
          team_name
        })),
        credentials: 'include',
        ...(abortSignal ? { signal: abortSignal } : {})
      });
      return resp;
    }
    async getTopQueries(client_id, service_id, email, menu, submenu, employee_id, call_time, audio_duration, custom_start, custom_end, record_type=null, team_name=undefined, abortSignal=null){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/concern_query/top_queries/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          employee_id,
          call_time,
          audio_duration,
          custom_start,
          custom_end,
          record_type,
          team_name
        })),
        credentials: 'include',
        ...(abortSignal ? { signal: abortSignal } : {})
      });
      return resp;
    }
    async getAgentFeedbackOverall(client_id, service_id, email, menu, submenu, employee, call_time, audio_duration, custom_start, custom_end, record_type=null, team_name=undefined, abortSignal=null){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/agent_feedback/overall/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          employee_id: employee,
          call_time,
          audio_duration,
          custom_start,
          custom_end,
          record_type,
          team_name
        })),
        credentials: 'include',
        ...(abortSignal ? { signal: abortSignal } : {})
      });
      return resp;
    }
    async getTopConcerns(client_id, service_id, email, menu, submenu, employee_id, call_time, audio_duration, custom_start, custom_end, record_type=null, team_name=undefined, abortSignal=null){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/concern_query/top_concerns/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          employee_id,
          call_time,
          audio_duration,
          custom_start,
          custom_end,
          record_type,
          team_name
        })),
        credentials: 'include',
        ...(abortSignal ? { signal: abortSignal } : {})
      });
      return resp;
    }
    async getAgentWisePerformanceDistribution(client_id, service_id, email, menu, submenu, employee_id, call_time, audio_duration,custom_start, custom_end, record_type, parameters, customer_id, fatal, open_concerns, conversation_type, conversation_potential, score_lower, score_upper, agent_feedback_parameter, business_insight_parameter, concern_category, concern_subcategory, query_category, query_subcategory, disposition, subdisposition, conversation_direction, lead_source, primary_language, secondary_languages, lead_sub_source, tag, tag2, tag3, tag4, tag5, tag6, tag7, tag8, tag9, tag10, tag11, tag12, tag13, tag14, tag15, tag16, tag17, tag18, tag19, tag20, tag21, tag22, tag23, tag24, tag25, tag26, tag27, tag28, tag29, tag30, campaign_id, actor_type, crm_lead_stage, crm_lead_sub_stage, customer_phone_number, crm_location, first_proper_conversation, custom_module_parameter_name = undefined, custom_module_parameter_answer = undefined, abortSignal=null, module_parameter_filters=undefined, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined, team_name=undefined){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/agent_feedback/agent_wise/performance_distribution/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          employee_id,
          call_time,
          audio_duration,
          parameters,
          custom_start,
          custom_end,
          record_type,
          customer_id,
          fatal,
          open_concerns,
          conversation_type,
          conversation_potential,
          score_lower,
          score_upper,
          agent_feedback_parameter,
          business_insight_parameter,
          concern_category,
          concern_subcategory,
          query_category,
          query_subcategory,
          disposition,
          subdisposition,
          conversation_direction,
          lead_source,
          primary_language,
          secondary_languages,
          lead_sub_source,
          tag,
          tag2,
          tag3,
          tag4,
          tag5,
          tag6,
          tag7,
          tag8,
          tag9,
          tag10,
          tag11,
          tag12,
          tag13,
          tag14,
          tag15,
          tag16,
          tag17,
          tag18,
          tag19,
          tag20,
          tag21,
          tag22,
          tag23,
          tag24,
          tag25,
          tag26,
          tag27,
          tag28,
          tag29,
          tag30,
          campaign_id,
          actor_type,
          crm_lead_stage,
          crm_lead_sub_stage,
          customer_phone_number,
          crm_location,
          crm_lead_created_at,
          crm_lead_created_at_start,
          crm_lead_created_at_end,
          crm_lead_created_at_range_type,
          team_name,
          first_proper_conversation,
          custom_module_parameter_name,
          custom_module_parameter_answer,
          module_parameter_filters
        })),
        credentials: 'include',
        ...(abortSignal ? { signal: abortSignal } : {})
      });
      return resp;
    }
    async getTeamWisePerformanceDistribution(client_id, service_id, email, menu, submenu, employee_id, call_time, audio_duration,custom_start, custom_end, record_type, parameters, customer_id, fatal, open_concerns, conversation_type, conversation_potential, score_lower, score_upper, agent_feedback_parameter, business_insight_parameter, concern_category, concern_subcategory, query_category, query_subcategory, disposition, subdisposition, conversation_direction, lead_source, primary_language, secondary_languages, lead_sub_source, tag, tag2, tag3, tag4, tag5, tag6, tag7, tag8, tag9, tag10, tag11, tag12, tag13, tag14, tag15, tag16, tag17, tag18, tag19, tag20, tag21, tag22, tag23, tag24, tag25, tag26, tag27, tag28, tag29, tag30, campaign_id, actor_type, crm_lead_stage, crm_lead_sub_stage, customer_phone_number, crm_location, first_proper_conversation, custom_module_parameter_name = undefined, custom_module_parameter_answer = undefined, abortSignal=null, module_parameter_filters=undefined, crm_lead_created_at=undefined, crm_lead_created_at_start=undefined, crm_lead_created_at_end=undefined, crm_lead_created_at_range_type=undefined, team_name=undefined){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/agent_feedback/team_wise/performance_distribution/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildDashboardFilterPayload({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          employee_id,
          call_time,
          audio_duration,
          parameters,
          custom_start,
          custom_end,
          record_type,
          customer_id,
          fatal,
          open_concerns,
          conversation_type,
          conversation_potential,
          score_lower,
          score_upper,
          agent_feedback_parameter,
          business_insight_parameter,
          concern_category,
          concern_subcategory,
          query_category,
          query_subcategory,
          disposition,
          subdisposition,
          conversation_direction,
          lead_source,
          primary_language,
          secondary_languages,
          lead_sub_source,
          tag,
          tag2,
          tag3,
          tag4,
          tag5,
          tag6,
          tag7,
          tag8,
          tag9,
          tag10,
          tag11,
          tag12,
          tag13,
          tag14,
          tag15,
          tag16,
          tag17,
          tag18,
          tag19,
          tag20,
          tag21,
          tag22,
          tag23,
          tag24,
          tag25,
          tag26,
          tag27,
          tag28,
          tag29,
          tag30,
          campaign_id,
          actor_type,
          crm_lead_stage,
          crm_lead_sub_stage,
          customer_phone_number,
          crm_location,
          crm_lead_created_at,
          crm_lead_created_at_start,
          crm_lead_created_at_end,
          crm_lead_created_at_range_type,
          team_name,
          first_proper_conversation,
          custom_module_parameter_name,
          custom_module_parameter_answer,
          module_parameter_filters
        })),
        credentials: 'include',
        ...(abortSignal ? { signal: abortSignal } : {})
      });
      return resp;
    }
    async getProjectStatus(client_id, service_id, email, menu, submenu, url){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/project_status/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&url=${url}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      });
      return resp;
    }
    async postProjectStatus(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/project_status/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include'
      });
      return resp;
    }
    async batchRecord(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/batch_record/`, {
        method: 'POST',
        headers: {
          'Accept': '*/*',
        },
        body: data,
        credentials: 'include'
      });
      return resp;
    }
    async singleRecord(formData) {
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/single_record/`, {
        method: 'POST',
        headers: {
          // Do not set Content-Type header here
          'Accept': '*/*',
        },
        body: formData, // Directly use formData here
        credentials: 'include', // Ensure cookies/session data is included
      });
      return resp;
    }
    async generateSampleModuleOutputs(data) {
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/module_sample_outputs/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      });
      return resp;
    }
    async deployModule(data) {
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/version_module_configuration/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      });
      return resp;
    }
    async validateModuleJsonConfiguration(data) {
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/configure/validate_module_json_configuration/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      });
      return resp;
    }
    async checkConversationChanges(client_id, service_id, email, menu, submenu, configuration) {
      const normalizedSubmenu = (typeof submenu === 'undefined') ? 'undefined' : submenu;
      const parsedConfig = (typeof configuration === 'string') ? JSON.parse(configuration) : configuration;
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/apply_conversations/check/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          client_id,
          service_id,
          email,
          menu,
          submenu: normalizedSubmenu,
          configuration: parsedConfig,
        }),
      });
      return resp;
    }
    async applyConversationChanges(data) {
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/apply_conversations/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async contactUs(data) {
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/contact_us/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async getAllNotifications(client_id, service_id, email, menu, submenu, start_time, end_time){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/notifications/all/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&start_time=${start_time}&end_time=${end_time}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getUnreadNotificationCount(client_id, service_id, email, menu, submenu, start_time, end_time){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/notifications/unread/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&start_time=${start_time}&end_time=${end_time}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getBusinessInsightsTags(client_id, service_id, email, menu, submenu, module_name){
      let url = `${apiUrl}/api/internal/new_dashboard/business_insights/tags/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}`;
      if (module_name) url += `&module_name=${module_name}`;
      let resp = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getDefaultModuleConfiguration(client_id, service_id, email, menu, submenu, module_name){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/default_module_configuration/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&module_name=${module_name}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async postBusinessInsightTag(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/business_insights/tags/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async markNotificationAsRead(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/notifications/unread/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async verifyQuery(client_id, service_id, query, selectedParameters, subparameters, return_type, subparameter_match_type) {
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/logic_parser/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({'logic':query, 'selected_parameters': selectedParameters, 'subparameters': subparameters, 'return_type': return_type, 'subparameter_match_type': subparameter_match_type, client_id, service_id}),
        credentials: 'include',
      })
      return resp;
    }
    async updateProjectDetails(data) {
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/project_configure/update/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async getClientBalanceSnapshot(client_id, service_id, email, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/billing/client_balance_snapshot/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getClientDailyUsageSummary(client_id, service_id, email, menu, submenu, month, year){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/billing/client_daily_usage_summary/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&month=${month}&year=${year}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getClientMonthlyUsageSummary(client_id, service_id, email, menu, submenu, month, year){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/billing/client_monthly_usage_summary/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&month=${month}&year=${year}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getClientTransactionsDetails(client_id, service_id, email, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/billing/client_transactions_details/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getClientPlansDetails(client_id, service_id, email, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/billing/client_pricing_details/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getFatalCalls(client_id, service_id, email, page, menu, submenu, time, customStart, customEnd){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/fatal_calls/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          client_id,
          service_id,
          email,
          page,
          menu,
          submenu,
          time,
          custom_start: customStart,
          custom_end: customEnd
        }),
        credentials: 'include',
      })
      return resp;
    }
    async getQueuedCalls(client_id, service_id, email, page, menu, submenu, time, customStart, customEnd, agent, conversation_id){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/queued_calls/?client_id=${client_id}&service_id=${service_id}&email=${email}&page_number=${page}&menu=${menu}&submenu=${submenu}&time=${time}&custom_start=${customStart}&custom_end=${customEnd}&agent=${agent}&conversation_id=${conversation_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async cancel_voice_agent_queued_call(client_id, service_id, email, menu, submenu, processing_id, conversation_id){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/queued_call_cancel/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({client_id, service_id, email, menu, submenu, processing_id, conversation_id}),
      })
      return resp;
    }
    async getModuleDraftSaveConfiguration(client_id, service_id, email, menu, submenu, module_name){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/module_draft_save_configuration/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&module_name=${module_name}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async get_all_clients(client_id, service_id, email, role, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/get_all_clients/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&role=${role}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getTaskStatusList(client_id, service_id, email, menu, submenu, timeFilter){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/task_status/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&created_at=${timeFilter}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async update_task_status(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/task_status/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async postModuleDraftSaveConfiguration(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/module_draft_save_configuration/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async getTestSamplesList(client_id, service_id, email, menu, submenu, module_name){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/configure/test_samples/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&module_name=${module_name}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async postTestSamples(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/configure/test_samples/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async updateTestSamples(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/configure/update_samples/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async get_custom_reports_list(client_id, service_id, email, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/custom_reports/reports_list/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async get_custom_report_details(client_id, service_id, email, report_id, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/custom_reports/report_details/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&report_id=${report_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async saveCustomReportConfiguration(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/custom_reports/report_configuration/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async getCustomReportConfiguration(client_id, service_id, email, menu, submenu, report_id){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/custom_reports/report_configuration/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&report_id=${report_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async post_custom_report_details(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/custom_reports/report_details/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async delete_custom_report(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/custom_reports/report_details/`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async reorder_custom_reports(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/custom_reports/reports_order/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async customReportTable(data, signal) {
      return fetch(`${apiUrl}/api/internal/new_dashboard/custom_reports/table_results/`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data), credentials: 'include', signal,
      });
    }
    async custom_report_execution(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/custom_reports/report_execution/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async getCustomReportDrilldown(data, abortSignal){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/custom_reports/report_drilldown/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
        ...(abortSignal ? { signal: abortSignal } : {})
      });
      return resp;
    }
    async downloadCustomReportExcel(client_id, service_id, email, report_id, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/custom_reports/download_custom_report/?client_id=${client_id}&service_id=${service_id}&email=${email}&report_id=${report_id}&menu=${menu}&submenu=${submenu}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getChatTranscriptionData(anthro_id, client_id, service_id, menu, submenu, email, url){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/chat_transcription/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&anthro_id=${anthro_id}&url=${url}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async generateLogicWithAI(client_id, service_id, menu, submenu, email, prompt, subparameters){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/logic_parser/generate_logic/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          client_id,
          service_id,
          menu,
          submenu,
          email,
          prompt,
          subparameters
        }),
        credentials: 'include',
      })
      return resp;
    }
    async getReportDataList(client_id, service_id, menu, submenu, email, created_at, custom_start, custom_end, report_type, employee_id=null, team_name=null){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/reports/reports_list/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&created_at=${created_at}&custom_start=${custom_start}&custom_end=${custom_end}&report_type=${report_type}&employee_id=${employee_id}&team_name=${team_name}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getDetailedReportData(client_id, service_id, email, report_id, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/reports/report_details/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&report_id=${report_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getTrainingDataList(client_id, service_id, email, menu, submenu, created_at, custom_start, custom_end, employee_id=null, completion_status=null, team_name=null){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/training/training_list/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&created_at=${created_at}&custom_start=${custom_start}&custom_end=${custom_end}&employee_id=${employee_id}&completion_status=${completion_status}&team_name=${team_name}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getTrainingDataDetails(client_id, service_id, email, training_id, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/training/training_details/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&training_session_id=${training_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async evaluateAgentResponse(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/training/evaluate_agent_response/`, {
        method: 'POST',
        headers: {
          'Accept': '*/*',
        },
        body: data,
        credentials: 'include',
      })
      return resp;
    }
    async generateReport(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/reports/generate_report/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
      async getAgentFeedbackConversations(client_id, service_id, email, menu, submenu, start_time, end_time, report_category, employee_ids, generate_training_session){
    const params = new URLSearchParams({
      client_id,
      service_id,
      email,
      menu,
      submenu,
      start_time,
      end_time,
      report_category,
      employee_ids: JSON.stringify(employee_ids),
      generate_training_session
    });
    
    let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/reports/get_agent_feedback_conversations/?${params}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    })
    return resp;
  }
    async generateTrainingSession(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/training/generate_training_session/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async getSystemConfiguration(client_id, service_id, email, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/reports/system_reports/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async saveSystemConfiguration(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/reports/system_reports/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }

    // Forms API Methods
    async getFormsList(client_id, service_id, email, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/forms/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    
    async createForm(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/forms/create/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    
    async getFormDetails(client_id, service_id, form_id, email, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/forms/details/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&form_id=${form_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    
    async updateForm(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/forms/edit/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    
    async deleteForm(form_id, client_id, service_id, email){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/forms/delete/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({client_id, service_id, email, form_id}),
        credentials: 'include',
      })
      return resp;
    }
    
    async updateFormStatus(form_id, status, email, client_id, service_id){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/forms/status/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({status, email, client_id, service_id, form_id}),
        credentials: 'include',
      })
      return resp;
    }
    
    // Public Form API Methods (no authentication required)
    async getPublicForm(form_id){
      let resp = await fetch(`${apiUrl}/api/public/forms/?form_id=${form_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    
    async submitPublicForm(data){
      let resp = await fetch(`${apiUrl}/api/public/forms/submit/`, {
        method: 'POST',
        headers: {
          // Do not set Content-Type header here
          'Accept': '*/*',
        },
        body: data,
      })
      return resp;
    }
    
    async getFormSubmissions(client_id, service_id, form_id, email, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/forms/${form_id}/submissions/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }

    async getMcpPromptManagementList(data){
      const params = new URLSearchParams();
      Object.entries(data || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') params.append(key, value);
      });
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/mcp_prompt_management/?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }

    async getMcpPromptManagementDetails(data){
      const params = new URLSearchParams();
      Object.entries(data || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') params.append(key, value);
      });
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/mcp_prompt_management/details/?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }

    async createMcpPromptManagement(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/mcp_prompt_management/create/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }

    async updateMcpPromptManagement(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/mcp_prompt_management/edit/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }

    async updateMcpPromptManagementStatus(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/mcp_prompt_management/status/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }

    async getDeveloperHubConfiguration(client_id, service_id, email, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/developer_hub_configuration/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async saveDeveloperHubConfiguration(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/developer_hub_configuration/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async getDeveloperHubWidgetConfigurations(client_id, service_id, email, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/developer_hub_configuration/widgets_list/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getDeveloperHubWidgetDetails(client_id, service_id, email, widget_id, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/developer_hub_configuration/widget_configuration/?client_id=${client_id}&service_id=${service_id}&email=${email}&widget_id=${widget_id}&menu=${menu}&submenu=${submenu}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async saveDeveloperHubWidgetConfiguration(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/developer_hub_configuration/widget_configuration/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async getClientEventConfigurations(client_id, service_id, email, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/developer_hub_configuration/events_list/?client_id=${encodeURIComponent(client_id)}&service_id=${encodeURIComponent(service_id)}&email=${email}&menu=${menu}&submenu=${submenu}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getClientEventRecords(data, signal){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/client_events/records/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
        signal,
      })
      return resp;
    }
    async getClientEventErrorCases(data, signal){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/client_events/error_cases/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
        signal,
      })
      return resp;
    }
    async downloadClientEventRecords(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/client_events/download/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async getClientEventDetails(client_id, service_id, email, event_reference_id, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/client_events/details/?client_id=${encodeURIComponent(client_id)}&service_id=${encodeURIComponent(service_id)}&email=${email}&event_reference_id=${encodeURIComponent(event_reference_id)}&menu=${menu}&submenu=${submenu}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async saveClientEventConfiguration(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/developer_hub_configuration/event_configuration/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async generateNewApiKey(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/developer_hub_configuration/generate_anthropod_api_key/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async getMcpConfiguration(client_id, service_id, email, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/developer_hub_configuration/mcp_configuration/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async updateMcpEnable(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/developer_hub_configuration/mcp_enable/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async generateMcpCredential(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/developer_hub_configuration/generate_mcp_credential/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async rotateMcpSecret(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/developer_hub_configuration/rotate_mcp_secret/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async getMcpOAuthConsentContext(request_id){
      const params = new URLSearchParams({ request_id });
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/mcp_oauth/consent_context/?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async approveMcpOAuthConsent(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/mcp_oauth/approve/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async denyMcpOAuthConsent(data){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/mcp_oauth/deny/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async checkDefinitionValidity(client_id, service_id, email, menu, submenu, definition, type, options, module_name){
      const normalizedSubmenu = (typeof submenu === 'undefined') ? 'undefined' : submenu;
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/configure/check_definition_validity/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          client_id,
          service_id,
          email,
          menu,
          subMenu: normalizedSubmenu,
          definition,
          type,
          options: options,
          module_name
        }),
      })
      return resp;
    }
    async postReminder(data) {
      try {
        let url = apiUrl + `/api/internal/reminder/reminders/`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              data
            })
          });
          if (!response.ok) {
            // Read the response body for detailed error message
            const errorResponse = await response.json();
            return {errorResponse};
        }
        let status = response.status;

        const resData = await response.json();
        return {resData, status};
        
      } catch (error) {
        console.error('Error posting reminder:', error);
        throw error;
      }
    }
    async getReminders(start, end) {
      try {
        let url = apiUrl + `/api/internal/reminder/reminders/?start_time=${start}&end_time=${end}`;
        const response = await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          });
          if (!response.ok) {
            // Read the response body for detailed error message
            const errorResponse = await response.json();
            return {errorResponse};
        }
        let status = response.status;

        const resData = await response.json();
        return {resData, status};
        
      } catch (error) {
        console.error('Error getting reminder:', error);
        throw error;
      }
    }
    async deleteReminder(id) {
      try {
        let url = apiUrl + `/api/internal/reminder/delete_reminder/`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              reminder_id: id
            })
          });
          if (!response.ok) {
            // Read the response body for detailed error message
            const errorResponse = await response.json();
            return {errorResponse};
        }
        let status = response.status;

        const resData = await response.json();
        return {resData, status};
        
      } catch (error) {
        console.error('Error deleting reminder:', error);
        throw error;
      }
    }
    async getAgentWidgets(context, signal) {
      return fetch(`${apiUrl}/api/internal/voice_agents_dashboard/agent_widgets/list/?${new URLSearchParams(context)}`, {
        credentials: 'include', signal,
      });
    }
    async getAgentWidget(context, widget_id, signal) {
      return fetch(`${apiUrl}/api/internal/voice_agents_dashboard/agent_widgets/configuration/?${new URLSearchParams({ ...context, widget_id })}`, {
        credentials: 'include', signal,
      });
    }
    async saveAgentWidget(context, configuration, resource) {
      return fetch(`${apiUrl}/api/internal/voice_agents_dashboard/agent_widgets/configuration/`, {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...context, configuration,
          ...(resource ? { widget_id: resource.widget_id, expected_version: resource.version } : {}),
        }),
      });
    }
    async getAgentsList(client_id, service_id, email, menu, submenu){
      const sid = (service_id == null ? '' : service_id);
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/agents_list/?client_id=${client_id}&service_id=${sid}&email=${email}&menu=${menu}&submenu=${submenu}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getAgentDetails(client_id, service_id, email, menu, submenu, agent_id){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/agent_detail/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&agent_id=${agent_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async saveAgentDetails(data){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/save_agent/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async validateVoiceAgentConfiguration(data){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/validate_agent_configuration/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
        credentials: 'include',
      })
      return resp;
    }
    async getVoiceAgentsOverallMetrics(client_id, service_id, email, menu, submenu, conversation_id, agent, time, custom_start, custom_end, mode, audio_duration, conversation_direction, customer_id, disconnect_type, disconnect_reason, average_latency, campaign_id, campaign_batch_id, transfer_status, transfer_agent_answered, business_insights_multiple, crm_update_status){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/overall_metrics/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&conversation_id=${conversation_id}&agent=${agent}&time=${time}&custom_start=${custom_start}&custom_end=${custom_end}&mode=${mode}&audio_duration=${audio_duration}&conversation_direction=${conversation_direction}&customer_id=${customer_id}&disconnect_type=${disconnect_type}&disconnect_reason=${disconnect_reason}&average_latency=${average_latency}&campaign_id=${campaign_id}&campaign_batch_id=${campaign_batch_id}&transfer_status=${transfer_status}&transfer_agent_answered=${transfer_agent_answered}&business_insights_multiple=${business_insights_multiple}&crm_update_status=${crm_update_status}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getVoiceAgentsMetricsDistribution(client_id, service_id, email, menu, submenu, conversation_id, agent, time, custom_start, custom_end, mode, audio_duration, conversation_direction, customer_id, disconnect_type, disconnect_reason, average_latency, campaign_id, campaign_batch_id, transfer_status, transfer_agent_answered, business_insights_multiple, crm_update_status){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/metrics_distribution/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&conversation_id=${conversation_id}&agent=${agent}&time=${time}&custom_start=${custom_start}&custom_end=${custom_end}&mode=${mode}&audio_duration=${audio_duration}&conversation_direction=${conversation_direction}&customer_id=${customer_id}&disconnect_type=${disconnect_type}&disconnect_reason=${disconnect_reason}&average_latency=${average_latency}&campaign_id=${campaign_id}&campaign_batch_id=${campaign_batch_id}&transfer_status=${transfer_status}&transfer_agent_answered=${transfer_agent_answered}&business_insights_multiple=${business_insights_multiple}&crm_update_status=${crm_update_status}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getVoiceAgentCallDetailsMetricsDistribution(client_id, service_id, email, menu, submenu, conversation_id, agent, time, custom_start, custom_end, mode, audio_duration, conversation_direction, customer_id, disconnect_type, disconnect_reason, average_latency, campaign_id, campaign_batch_id, transfer_status, transfer_agent_answered, business_insights_multiple, crm_update_status){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/call_details_metrics_distribution/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&conversation_id=${conversation_id}&agent=${agent}&time=${time}&custom_start=${custom_start}&custom_end=${custom_end}&mode=${mode}&audio_duration=${audio_duration}&conversation_direction=${conversation_direction}&customer_id=${customer_id}&disconnect_type=${disconnect_type}&disconnect_reason=${disconnect_reason}&average_latency=${average_latency}&campaign_id=${campaign_id}&campaign_batch_id=${campaign_batch_id}&transfer_status=${transfer_status}&transfer_agent_answered=${transfer_agent_answered}&business_insights_multiple=${business_insights_multiple}&crm_update_status=${crm_update_status}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getVoiceAgentCustomerDetailsMetricsDistribution(client_id, service_id, email, menu, submenu, conversation_id, agent, time, custom_start, custom_end, mode, audio_duration, conversation_direction, customer_id, disconnect_type, disconnect_reason, average_latency, campaign_id, campaign_batch_id, transfer_status, transfer_agent_answered, business_insights_multiple, crm_update_status){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/customer_details_metrics_distribution/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&conversation_id=${conversation_id}&agent=${agent}&time=${time}&custom_start=${custom_start}&custom_end=${custom_end}&mode=${mode}&audio_duration=${audio_duration}&conversation_direction=${conversation_direction}&customer_id=${customer_id}&disconnect_type=${disconnect_type}&disconnect_reason=${disconnect_reason}&average_latency=${average_latency}&campaign_id=${campaign_id}&campaign_batch_id=${campaign_batch_id}&transfer_status=${transfer_status}&transfer_agent_answered=${transfer_agent_answered}&business_insights_multiple=${business_insights_multiple}&crm_update_status=${crm_update_status}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getConnectedCallsSlotDistribution(client_id, service_id, email, menu, submenu, conversation_id, agent, time, custom_start, custom_end, mode, audio_duration, conversation_direction, customer_id, disconnect_type, disconnect_reason, average_latency, campaign_id, campaign_batch_id, transfer_status, transfer_agent_answered, business_insights_multiple, crm_update_status){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/connected_calls_slot_distribution/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&conversation_id=${conversation_id}&agent=${agent}&time=${time}&custom_start=${custom_start}&custom_end=${custom_end}&mode=${mode}&audio_duration=${audio_duration}&conversation_direction=${conversation_direction}&customer_id=${customer_id}&disconnect_type=${disconnect_type}&disconnect_reason=${disconnect_reason}&average_latency=${average_latency}&campaign_id=${campaign_id}&campaign_batch_id=${campaign_batch_id}&transfer_status=${transfer_status}&transfer_agent_answered=${transfer_agent_answered}&business_insights_multiple=${business_insights_multiple}&crm_update_status=${crm_update_status}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async getVoiceAgentsMetricsFilters(client_id, service_id, email, menu, submenu){
      const sid = (service_id == null ? '' : service_id);
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/filters/?client_id=${client_id}&service_id=${sid}&email=${email}&menu=${menu}&submenu=${submenu}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      return resp;
    }
    async browserTesting(client_id, agent_id, email, menu, submenu, status){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/make_browser_call/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({client_id, agent_id, email, menu, submenu, status}),
        credentials: 'include',
      })
      return resp;
    }
    async test_voice_agent_outbound_call(client_id, agent_id, phone_number, agent_phone_number, email, menu, submenu, status){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/make_outbound_call/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({client_id, agent_id, phone_number, agent_phone_number, email, menu, submenu, status}),
        credentials: 'include',
      })
      return resp;
    }
    async check_voice_enabled(client_id, service_id, email, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/new_dashboard/voice_enabled/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    async get_voice_agent_calls_list(client_id, service_id, email, menu, submenu, page_number, conversation_id, agent_id, time_filter, custom_start, custom_end, audio_duration, conversation_direction, customer_id, disconnect_type, disconnect_reason, average_latency, campaign_id, campaign_batch_id, mode, transfer_status, transfer_agent_answered, business_insights_multiple, crm_update_status, record_type='call'){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/calls_list/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&page_number=${page_number}&conversation_id=${conversation_id}&agent_id=${agent_id}&time=${time_filter}&custom_start=${custom_start}&custom_end=${custom_end}&audio_duration=${audio_duration}&conversation_direction=${conversation_direction}&customer_id=${customer_id}&disconnect_type=${disconnect_type}&disconnect_reason=${disconnect_reason}&average_latency=${average_latency}&campaign_id=${campaign_id}&campaign_batch_id=${campaign_batch_id}&mode=${mode}&transfer_status=${transfer_status}&transfer_agent_answered=${transfer_agent_answered}&business_insights_multiple=${business_insights_multiple}&crm_update_status=${crm_update_status}&record_type=${encodeURIComponent(record_type || 'call')}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    async download_voice_agent_calls(client_id, service_id, email, menu, submenu, conversation_id, agent_id, time_filter, custom_start, custom_end, audio_duration, conversation_direction, customer_id, disconnect_type, disconnect_reason, average_latency, campaign_id, campaign_batch_id, mode, transfer_status, transfer_agent_answered, business_insights_multiple, crm_update_status){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/download_calls/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&conversation_id=${conversation_id}&agent_id=${agent_id}&time=${time_filter}&custom_start=${custom_start}&custom_end=${custom_end}&audio_duration=${audio_duration}&conversation_direction=${conversation_direction}&customer_id=${customer_id}&disconnect_type=${disconnect_type}&disconnect_reason=${disconnect_reason}&average_latency=${average_latency}&campaign_id=${campaign_id}&campaign_batch_id=${campaign_batch_id}&mode=${mode}&transfer_status=${transfer_status}&transfer_agent_answered=${transfer_agent_answered}&business_insights_multiple=${business_insights_multiple}&crm_update_status=${crm_update_status}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    async get_voice_agent_call_details(client_id, service_id, email, menu, submenu, conversation_id){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/call_details/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&conversation_id=${conversation_id}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    async getVoiceAgentDisconnectReasonsDistribution(client_id, service_id, email, menu, submenu, conversation_id, agent, time, custom_start, custom_end, mode, audio_duration, conversation_direction, customer_id, disconnect_type, disconnect_reason, average_latency, campaign_id, campaign_batch_id, transfer_status, transfer_agent_answered, business_insights_multiple, crm_update_status){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/disconnect_reason_distribution/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&conversation_id=${conversation_id}&agent=${agent}&time=${time}&custom_start=${custom_start}&custom_end=${custom_end}&mode=${mode}&audio_duration=${audio_duration}&conversation_direction=${conversation_direction}&customer_id=${customer_id}&disconnect_type=${disconnect_type}&disconnect_reason=${disconnect_reason}&average_latency=${average_latency}&campaign_id=${campaign_id}&campaign_batch_id=${campaign_batch_id}&transfer_status=${transfer_status}&transfer_agent_answered=${transfer_agent_answered}&business_insights_multiple=${business_insights_multiple}&crm_update_status=${crm_update_status}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    async getVoiceAgentDisconnectTypesDistribution(client_id, service_id, email, menu, submenu, conversation_id, agent, time, custom_start, custom_end, mode, audio_duration, conversation_direction, customer_id, disconnect_type, disconnect_reason, average_latency, campaign_id, campaign_batch_id, transfer_status, transfer_agent_answered, business_insights_multiple, crm_update_status){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/disconnect_type_distribution/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&conversation_id=${conversation_id}&agent=${agent}&time=${time}&custom_start=${custom_start}&custom_end=${custom_end}&mode=${mode}&audio_duration=${audio_duration}&conversation_direction=${conversation_direction}&customer_id=${customer_id}&disconnect_type=${disconnect_type}&disconnect_reason=${disconnect_reason}&average_latency=${average_latency}&campaign_id=${campaign_id}&campaign_batch_id=${campaign_batch_id}&transfer_status=${transfer_status}&transfer_agent_answered=${transfer_agent_answered}&business_insights_multiple=${business_insights_multiple}&crm_update_status=${crm_update_status}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    async getVoiceAgentTransferStatusDistribution(client_id, service_id, email, menu, submenu, conversation_id, agent_id, time, custom_start, custom_end, mode, audio_duration, conversation_direction, customer_id, disconnect_type, disconnect_reason, average_latency, campaign_id, campaign_batch_id, transfer_status, transfer_agent_answered, business_insights_multiple, crm_update_status){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/transfer_status_distribution/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&conversation_id=${conversation_id}&agent=${agent_id}&time=${time}&custom_start=${custom_start}&custom_end=${custom_end}&mode=${mode}&audio_duration=${audio_duration}&conversation_direction=${conversation_direction}&customer_id=${customer_id}&disconnect_type=${disconnect_type}&disconnect_reason=${disconnect_reason}&average_latency=${average_latency}&campaign_id=${campaign_id}&campaign_batch_id=${campaign_batch_id}&transfer_status=${transfer_status}&transfer_agent_answered=${transfer_agent_answered}&business_insights_multiple=${business_insights_multiple}&crm_update_status=${crm_update_status}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    async getVoiceAgentTransferAgentAnsweredDistribution(client_id, service_id, email, menu, submenu, conversation_id, agent_id, time, custom_start, custom_end, mode, audio_duration, conversation_direction, customer_id, disconnect_type, disconnect_reason, average_latency, campaign_id, campaign_batch_id, transfer_status, transfer_agent_answered, business_insights_multiple, crm_update_status){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/transfer_agent_answered_distribution/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&conversation_id=${conversation_id}&agent=${agent_id}&time=${time}&custom_start=${custom_start}&custom_end=${custom_end}&mode=${mode}&audio_duration=${audio_duration}&conversation_direction=${conversation_direction}&customer_id=${customer_id}&disconnect_type=${disconnect_type}&disconnect_reason=${disconnect_reason}&average_latency=${average_latency}&campaign_id=${campaign_id}&campaign_batch_id=${campaign_batch_id}&transfer_status=${transfer_status}&transfer_agent_answered=${transfer_agent_answered}&business_insights_multiple=${business_insights_multiple}&crm_update_status=${crm_update_status}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    async getVoiceAgentCrmUpdateStatusDistribution(client_id, service_id, email, menu, submenu, conversation_id, agent_id, time, custom_start, custom_end, mode, audio_duration, conversation_direction, customer_id, disconnect_type, disconnect_reason, average_latency, campaign_id, campaign_batch_id, transfer_status, transfer_agent_answered, business_insights_multiple, crm_update_status){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/crm_update_status_distribution/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&conversation_id=${conversation_id}&agent=${agent_id}&time=${time}&custom_start=${custom_start}&custom_end=${custom_end}&mode=${mode}&audio_duration=${audio_duration}&conversation_direction=${conversation_direction}&customer_id=${customer_id}&disconnect_type=${disconnect_type}&disconnect_reason=${disconnect_reason}&average_latency=${average_latency}&campaign_id=${campaign_id}&campaign_batch_id=${campaign_batch_id}&transfer_status=${transfer_status}&transfer_agent_answered=${transfer_agent_answered}&business_insights_multiple=${business_insights_multiple}&crm_update_status=${crm_update_status}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    async getVoiceAgentBusinessInsights(client_id, service_id, email, menu, submenu, conversation_id, agent_id, time, custom_start, custom_end, mode, audio_duration, conversation_direction, customer_id, disconnect_type, disconnect_reason, average_latency, campaign_id, campaign_batch_id, transfer_status, transfer_agent_answered, business_insights_multiple, crm_update_status){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/business_insights_distribution/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&conversation_id=${conversation_id}&agent_id=${agent_id}&time=${time}&custom_start=${custom_start}&custom_end=${custom_end}&mode=${mode}&audio_duration=${audio_duration}&conversation_direction=${conversation_direction}&customer_id=${customer_id}&disconnect_type=${disconnect_type}&disconnect_reason=${disconnect_reason}&average_latency=${average_latency}&campaign_id=${campaign_id}&campaign_batch_id=${campaign_batch_id}&transfer_status=${transfer_status}&transfer_agent_answered=${transfer_agent_answered}&business_insights_multiple=${business_insights_multiple}&crm_update_status=${crm_update_status}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    async get_voice_agent_customers_list(client_id, service_id, email, menu, submenu, page_number, id, agent, first_interaction_time, last_interaction_time, first_interaction_custom_start, first_interaction_custom_end, last_interaction_custom_start, last_interaction_custom_end){
      let encodedId = encodeURIComponent(id);
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/customers_list/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&page_number=${page_number}&customer_id=${encodedId}&agent=${agent}&first_interaction_time=${first_interaction_time}&last_interaction_time=${last_interaction_time}&first_interaction_time_custom_start=${first_interaction_custom_start}&first_interaction_time_custom_end=${first_interaction_custom_end}&last_interaction_time_custom_start=${last_interaction_custom_start}&last_interaction_time_custom_end=${last_interaction_custom_end}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    async get_voice_agent_customer_details(client_id, service_id, email, menu, submenu, customer_id){
      let encodedCustomerId = encodeURIComponent(customer_id);
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/customer_details/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&customer_id=${encodedCustomerId}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    async get_voice_agent_allowed_config(){
      let resp = await fetch(`${apiUrl}/api/v2/voice_agents/allowed_config/`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    
    async getVoiceSamples(provider = '', model = '', gender = '', voice = ''){
      const queryParams = new URLSearchParams();
      if (provider) queryParams.append('provider', encodeURIComponent(provider));
      if (model) queryParams.append('model', encodeURIComponent(model));
      if (gender) queryParams.append('gender', encodeURIComponent(gender));
      if (voice) queryParams.append('voice', encodeURIComponent(voice));
      
      const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
      
      let resp = await fetch(`${apiUrl}/api/v2/voice_agents/voice_samples/${queryString}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    async create_voice_agent_campaign(client_id, service_id, email, menu, submenu, campaign_id, campaign_name, agent, max_retries, phone){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/campaign_create/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({client_id, service_id, email, menu, submenu, campaign_id, campaign_name, agent, max_retries, phone}),
      })
      return resp;
    }
    async update_voice_agent_campaign(client_id, service_id, email, campaign_id, max_retries, phone){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/campaign_update/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({client_id, service_id, email, campaign_id, max_retries, phone}),
      })
      return resp;
    }
    async get_voice_agent_campaign_list(client_id, service_id, email, menu, submenu, page_number, id, agent, date, custom_start, custom_end){
      const sid = (service_id == null ? '' : service_id);
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/campaigns_list/?client_id=${client_id}&service_id=${sid}&email=${email}&menu=${menu}&submenu=${submenu}&page_number=${page_number}&id=${id}&agent=${agent}&date=${date}&custom_start=${custom_start}&custom_end=${custom_end}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    async get_voice_agent_campaign_details(client_id, service_id, email, menu, submenu, campaign_id){
      const sid = (service_id == null ? '' : service_id);
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/campaign_details/?client_id=${client_id}&service_id=${sid}&email=${email}&menu=${menu}&submenu=${submenu}&campaign_id=${campaign_id}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    async upload_voice_agent_campaign_batch(data){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/campaign_bulk_upload/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Accept': '*/*',
        },
        body: data,
      })
      return resp;
    }
    async cancel_voice_agent_campaign_batch(client_id, service_id, email, menu, submenu, campaign_id, campaign_batch_id){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/campaign_batch_cancel/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({client_id, service_id, email, menu, submenu, campaign_id, campaign_batch_id}),
      })
      return resp;
    }
    async manage_voice_agent_phone_number(data) {
      return fetch(`${apiUrl}/api/internal/voice_agents_dashboard/manage_phone_number/`, {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
    }
    async update_voice_agent_phone_number(client_id, service_id, email, menu, submenu, phone_number, agent, provider, alias_name, reject_incoming_calls, phone_number_change_frequency, routing_options = {}){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/phone_numbers/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          client_id,
          service_id,
          email,
          menu,
          submenu,
          phone_number,
          agent,
          provider,
          alias_name,
          reject_incoming_calls,
          routing_mode: routing_options.routing_mode || "direct",
          ivr_config: routing_options.ivr_config || {},
          ...(phone_number_change_frequency !== undefined && phone_number_change_frequency !== null
            ? { phone_number_change_frequency }
            : {}),
        }),
      })
      return resp;
    }
    async generate_voice_agent_phone_number(client_id, service_id, email, menu, submenu, current_phone_number, provider, managed_by){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/generate_phone_number/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({client_id, service_id, email, menu, submenu, current_phone_number, provider, managed_by}),
      })
      return resp;
    }
    async buy_voice_agent_phone_number(client_id, service_id, email, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/create_new_phone_number/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({client_id, service_id, email, menu, submenu}),
      })
      return resp;
    }

    async get_voice_agent_phone_number_list(client_id, service_id, email, menu, submenu, page_number, phone_number, agent, date, custom_start, custom_end){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/phone_numbers/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&page_number=${page_number}&phone_number=${phone_number}&agent=${agent}&date=${date}&custom_start=${custom_start}&custom_end=${custom_end}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    async get_voice_agent_saved_draft(client_id, service_id, email, menu, submenu, agent_id){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/saved_draft/?client_id=${client_id}&service_id=${service_id}&email=${email}&menu=${menu}&submenu=${submenu}&agent_id=${agent_id}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    async save_voice_agent_saved_draft(data){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/saved_draft/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
      })
      return resp;
    }
    async uploadPublicAsset(client_id, agent_id, email, menu, submenu, file){
      const formData = new FormData()
      formData.append('client_id', client_id)
      formData.append('agent_id', agent_id)
      formData.append('email', email)
      formData.append('menu', menu)
      formData.append('submenu', submenu)
      formData.append('file', file)
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/upload_public_asset/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Accept': '*/*',
        },
        body: formData,
      })
      return resp;
    }
    async generatePresignedUrl(client_id, agent_id, email, menu, submenu, file_path){
      let encodedFilePath = encodeURIComponent(file_path);
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/generate_presigned_url/?client_id=${client_id}&agent_id=${agent_id}&email=${email}&menu=${menu}&submenu=${submenu}&file_path=${encodedFilePath}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    async getKnowledgeBaseData(client_id, email, menu, submenu){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/knowledge_base_data/?client_id=${client_id}&email=${email}&menu=${menu}&submenu=${submenu}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    async getDoctorDirectory(params) {
      return fetch(`${apiUrl}/api/internal/voice_agents_dashboard/doctor_directory/?${new URLSearchParams(params)}`, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      });
    }
    async saveDoctorDirectory(data) {
      return fetch(`${apiUrl}/api/internal/voice_agents_dashboard/doctor_directory/`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
    }
    async createKnowledgeBase(data){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/knowledge_base_data/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Accept': '*/*',
        },
        body: data,
      })
      return resp;
    }
    async downloadKnowledgeBase(data){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/gcs_signed_download_url/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
      })
      return resp;
    }
    async knowledgeBaseDeleteImpact(client_id, email, menu, submenu, knowledge_base_id){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/delete_knowledge_base_data/?client_id=${client_id}&email=${email}&menu=${menu}&submenu=${submenu}&knowledge_base_id=${knowledge_base_id}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return resp;
    }
    async deleteKnowledgeBase(data){
      let resp = await fetch(`${apiUrl}/api/internal/voice_agents_dashboard/delete_knowledge_base_data/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...data}),
      })
      return resp;
    }
}

const server = new Server();

export default server;

export { apiUrl as agentWidgetsApiBaseUrl };
